import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';
import { Formik } from 'formik';
import * as Yup from 'yup';
import LoadingButton from '../../../components/@extended/LoadingButton';
import React, { useEffect, useState } from 'react';
import useAuth from '../../../hooks/useAuth';
import { useAccountClient, useTradeClient } from '../../../client/client-hook';
import { UpdateSymbolSettingsReq, RISK_TYPE, AssociatedMasterSymbolReq, AssociatedMasterSymbolReply } from '../../../proto/trade-copier_pb';
import { DispatchSnackbarService } from '../../../services';
import { useDispatch } from '../../../store';
import { CopyTradingTableDto, filter_type_map_value } from '../CopyTradingTableSection';
import IconButton from '../../../components/@extended/IconButton';
import { CaretRightFilled, CloseOutlined, InfoCircleFilled, WarningOutlined } from '@ant-design/icons';
import MainCard from '../../../components/MainCard';
import { CTIServerID, MIN_FIXED_LOT, MIN_RISK_SETTING, SeacrestMT5ServerID, SeacrestMTRServerID } from '../AddCopierSection';
import { useTheme } from '@mui/material/styles';
import RiskCalculatorModal from './RiskCalculatorModal';
import CalculatorSvg from '../../../assets/images/icons/calculator.svg';
import { TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { Alert } from '@mui/material';
import { AccountInfoLite, AccountListReply, AccountListReq } from 'proto/account-manager_pb';
import { cloneDeep } from 'lodash';
import FormikEffect from 'components/custom/FormikEffect';
import { Int64Value, StringValue } from 'google-protobuf/google/protobuf/wrappers_pb';
import { SymbolSettingTableDto } from './SymbolSettingsTableSection';
import SymbolAutocompleteWrapperUpdated from './SymbolAutocompleteWrapperUpdated';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 720,
  maxWidth: 800,
  bgcolor: 'background.paper',
  borderRadius: '8px'
};

type Props = {
  handleClose: (hasUnsaved?: boolean) => void;
  checkHasUnsaved: (hasUnsaved: boolean) => void;
  handleSuccess: () => void;
  symbolSettings: SymbolSettingTableDto | null;
  selectedMasterAccountId: string;
  selectedSlave: CopyTradingTableDto | null;
  isEdit: boolean;
  showWrapper?: boolean;
};

const riskTypeMapFromDisplayText: any = {
  'Fixed Lot': 1,
  'Lot Multiplier': 2,
  'Balance Multiplier': 3,
  'Fixed Balance Multiplier': 4,
  'Fixed % risk': 5
};

const service = new DispatchSnackbarService();

const SymbolSettingsForm = ({
  handleClose,
  handleSuccess,
  checkHasUnsaved,
  symbolSettings,
  selectedMasterAccountId,
  selectedSlave,
  isEdit,
  showWrapper = true
}: Props) => {
  const [apiCalling, setApiCalling] = useState(false);
  const { user } = useAuth();
  const tradeClient = useTradeClient();
  const accountClient = useAccountClient();
  const dispatch = useDispatch();
  const theme = useTheme();
  const [openRiskCalculator, setOpenRiskCalculator] = useState(false);
  const [copyExpanded, setCopyExpanded] = useState(true);
  const [advanceExpanded, setAdvanceExpanded] = useState(false);
  const [filterExpanded, setFilterExpanded] = useState(false);
  const [slTpExpand, setSlTpExpand] = useState(false);

  const isComment = () => {
    const copyTo = symbolSettings?.additionalProps?.platform;

    console.log('isComment: ', copyTo);

    return copyTo === 'MT-4' || copyTo === 'MT-5' || copyTo === 'CTR';
  };

  const handleEditSlave = (values: any) => {
    console.log('handleEditSlave: ', values);

    if (
      user &&
      user?.tcId &&
      values?.riskType &&
      !invalidTVMaster(values) &&
      (values?.masterSymbolName || currentMasterSymbol) &&
      (parseInt(values?.riskType) === RISK_TYPE.FIXED_BALANCE_MULTIPLIER ? values?.fixedMasterBalance > 0.01 : true) &&
      (parseInt(values?.riskType) === RISK_TYPE.LOT_MULTIPLIER ? values?.riskSettings > MIN_RISK_SETTING : true) &&
      (parseInt(values?.riskType) === RISK_TYPE.FIXED_LOT ? values?.riskSettingsFixedLot > MIN_FIXED_LOT : true) &&
      (parseInt(values?.riskType) === RISK_TYPE.BALANCE_MULTIPLIER ? values?.riskSettings > MIN_RISK_SETTING : true) &&
      (parseInt(values?.riskType) === RISK_TYPE.BALANCE_PERCENTAGE
        ? values?.riskSettingsBalancePercentage > 0 && values?.riskSettingsBalancePercentage <= 100
        : true) &&
      (parseInt(values?.riskType) !== RISK_TYPE.BALANCE_PERCENTAGE
        ? values?.riskSettings > MIN_RISK_SETTING || values?.riskSettingsFixedLot > MIN_FIXED_LOT
        : true) &&
      (values?.copyMagicNumber === 'Custom' ? values?.magicNumber <= 2147483647 && values?.magicNumber >= 1 : true) &&
      ((values?.magicFilter === 'COPY' || values?.magicFilter === 'IGNORE') && values?.magicFilterValue
        ? values?.magicFilterValue <= 2147483647 && values?.magicFilterValue >= 1
        : true) &&
      (values?.filterByLotSize === 'Yes'
        ? values?.filterByLotSizeMinValue >= 0.01 &&
          values?.filterByLotSizeMaxValue &&
          values?.filterByLotSizeMinValue <= values?.filterByLotSizeMaxValue
        : true) &&
      (values.delayType === 'random'
        ? !!values?.tradeDelayMin && !!values.tradeDelayMax && +values?.tradeDelayMin <= +values?.tradeDelayMax
        : values?.delayType === 'fixed'
        ? !!values?.tradeDelayMin
        : true) &&
      (values?.fixedStopLoss === 'Yes' ? values?.fixedStopLossValue > 0 : true) &&
      (values?.fixedTakeProfit === 'Yes' ? values?.fixedTakeProfitValue > 0 : true) &&
      (values?.stopLossRefinement === 'Yes' ? values?.stopLossRefinementValue != 0 : true) &&
      (values?.takeProfitRefinement === 'Yes' ? values?.takeProfitRefinementValue != 0 : true)
    ) {
      console.log('updateSlave: ', values);
      updateSettings(values);
    } else if (invalidTVMaster(values)) {
      service.dispatchSnackbar(dispatch, invalidTVMaster(values) as any, 'alert', 'error', 5000);
    } else if (values?.copyMagicNumber === 'Custom' && values?.magicNumber < 1) {
      service.dispatchSnackbar(dispatch, 'Custom Magic number range is 1 to 2147483647', 'alert', 'error', 5000);
    } else {
      service.dispatchSnackbar(dispatch, 'Invalid input', 'alert', 'error', 5000);
      // service.dispatchSnackbar(dispatch, 'Invalid input or you are not logged in', 'alert', 'error', 5000);
    }
  };

  const invalidTVMaster = (values: any) => {
    if (hasTVAccount()) {
      if (values.copyPendingOrders) {
        return 'Copy pending order not allowed for Tradovate';
      }
    }
    if (hasTVAccount()) {
      if (values.copyMagicNumber && (values.copyMagicNumber !== 'No' || +values?.magicNumber !== 0)) {
        return 'Copy magic number not allowed for Tradovate';
      }
      if (getMagicFilters(values) && getMagicFilters(values).length > 0) {
        return 'Magic filters not allowed for Tradovate';
      }
      if (getFilterComments(values) && getFilterComments(values).length > 0) {
        return 'Comment filters not allowed for Tradovate';
      }
    }
    return null;
  };

  const [loadingMasterSymbol, setLoadingMasterSymbol] = useState(false);
  const [currentMasterSymbol, setCurrentMasterSymbol] = useState('');

  const fetchMasterSymbol = async (symbol: string) => {
    try {
      setLoadingMasterSymbol(true);
      const client = await tradeClient();
      const req: AssociatedMasterSymbolReq.AsObject = {
        userId: user?.tcId || '',
        slaveId: selectedSlave?.id || '',
        slaveSymbol: symbol
      };
      const res = await client.associatedMasterSymbol(req);
      console.log('AssociatedMasterSymbol: ', res);
      const result = res as AssociatedMasterSymbolReply.AsObject;
      setCurrentMasterSymbol(result.masterSymbol);
      setLoadingMasterSymbol(false);
    } catch (err) {
      console.log('ERROR: ', err);
      setCurrentMasterSymbol('');
      setLoadingMasterSymbol(false);
    }
  };

  const updateSettings = (values: any) => {
    setApiCalling(true);
    tradeClient()
      .then((client) => {
        const riskType = values.riskType;
        console.log('UpdateSymbolSettingsReq: ', values);
        let req: UpdateSymbolSettingsReq.AsObject = {
          userId: user?.tcId || '',
          slaveId: selectedSlave?.id || '',
          slaveSymbolName: values.slaveSymbolName || '',
          masterSymbolName: values.masterSymbolName ? values.masterSymbolName : currentMasterSymbol || '',
          enable: { value: symbolSettings ? symbolSettings?.status === 'right' : true },
          riskType: values?.riskType,
          lotMultiplierValue: {
            value: riskType === RISK_TYPE.LOT_MULTIPLIER ? values?.riskSettings : 0
          },
          fixedLotValue: {
            value: riskType === RISK_TYPE.FIXED_LOT ? values?.riskSettingsFixedLot : 0
          },
          balanceMultiplierValue: {
            value: riskType === RISK_TYPE.BALANCE_MULTIPLIER ? values?.riskSettings : 0
          },
          balancePercentageValue: {
            value: riskType === RISK_TYPE.BALANCE_PERCENTAGE ? values.riskSettingsBalancePercentage : 0
          },
          copyTakeProfit: { value: values?.copyTakeProfit },
          copyStopLoss: { value: values?.copyStopLoss },
          copyPendingOrders: { value: values?.copyPendingOrders },
          forceMinimumLotSize: { value: values?.forceMinimumLotSize },
          forceMaximumLotSize: { value: values?.forceMaximumLotSize },
          copyComment: { value: values?.copyComment !== 'No' },
          customComment: { value: values?.customComment },
          reverseTrade: { value: values?.reverseTrade },
          strictClose: { value: values?.strictClose },
          considerContractSize: { value: values?.considerContractSize },
          copyMagicNumber: { value: values?.copyMagicNumber !== 'No' },
          magicNumber: { value: values?.copyMagicNumber !== 'Custom' ? 0 : values?.magicNumber },
          lotRefinerValue: { value: values?.lotRefiner || 0 },
          magicFilterType: filter_type_map_value[values.magicFilter],
          commentFilterType: filter_type_map_value[values.filterByComment],
          magicFiltersList: getMagicFilters(values),
          copyExpiryTime: { value: values?.copyExpiryTime },
          commentFiltersList: getFilterComments(values),
          minLotFilter: {
            value: values?.filterByLotSize === 'Yes' && values?.filterByLotSizeMinValue ? values?.filterByLotSizeMinValue : null
          },
          maxLotFilter: {
            value: values?.filterByLotSize === 'Yes' && values?.filterByLotSizeMaxValue ? values?.filterByLotSizeMaxValue : null
          },
          stopLossPip: {
            value: values?.fixedStopLoss === 'Yes' && values?.fixedStopLossValue ? values?.fixedStopLossValue : 0
          },
          takeProfitPip: {
            value: values?.fixedTakeProfit === 'Yes' && values?.fixedTakeProfitValue ? values?.fixedTakeProfitValue : 0
          },
          slRefiner: {
            value: values?.stopLossRefinement === 'Yes' && values?.stopLossRefinementValue ? values?.stopLossRefinementValue : 0
          },
          tpRefiner: {
            value: values?.takeProfitRefinement === 'Yes' && values?.takeProfitRefinementValue ? values?.takeProfitRefinementValue : 0
          },
          manageExisting: symbolSettings?.settings?.manageExisting,
          allowedTradeSide: { value: values?.directionType === 'ALL' ? null : values?.directionType }
          //   copyExistingTrades: {
          //     value: symbolSettings?.settings?.copyExistingTrades?.value || false
          //   },
          //   tradingHoursList: symbolSettings?.settings?.tradingHoursList || []
        };
        if (values.delayType === 'random') {
          if (!!values?.tradeDelayMin || values?.tradeDelayMin == 0) {
            req.minDelayTime = { value: +values.tradeDelayMin };
          }
          if (!!values?.tradeDelayMax || values?.tradeDelayMax == 0) {
            req.maxDelayTime = { value: +values.tradeDelayMax };
          }
        } else if (values.delayType === 'fixed') {
          if (!!values?.tradeDelayMin || values?.tradeDelayMin == 0) {
            req.minDelayTime = { value: +values.tradeDelayMin };
            req.maxDelayTime = { value: +values.tradeDelayMin };
          }
        } else if (values.delayType === 'no') {
          req.minDelayTime = { value: 0 };
          req.maxDelayTime = { value: 0 };
        }
        if (riskType === RISK_TYPE.FIXED_BALANCE_MULTIPLIER) {
          req.fixedBalanceMultiplierValue = {
            value: riskType === RISK_TYPE.FIXED_BALANCE_MULTIPLIER ? values?.riskSettings : 0
          };
          req.fixedMasterBalance = {
            value: values?.fixedMasterBalance
          };
        }
        console.log(req);
        client
          .overrideSymbolSettings(req as any)
          .then((res) => {
            console.log(res);
            setApiCalling(false);
            service.dispatchSnackbar(dispatch, 'Symbol copier updated successfully', 'alert', 'success', 5000);
            // sendCrispEvent(req, client, 'Symbol Config Modified', symbolSettings?.accountId, symbolSettings?.masterAccountNumber);
            handleSuccess();
            // handleClose();
          })
          .catch((err) => {
            console.log('ERROR: ', err);
            setApiCalling(false);
            const msz = err.message === 'no permission to access this RPC' ? 'Permission denied' : err.message;
            service.dispatchSnackbar(dispatch, msz, 'alert', 'error', 5000);
          });
      })
      .catch((err) => {
        console.log('ERROR: ', err);
        setApiCalling(false);
        const msz = err.message === 'no permission to access this RPC' ? 'Permission denied' : err.message;
        service.dispatchSnackbar(dispatch, msz, 'alert', 'error', 5000);
      });
  };

  const [isCTIAccount, setIsCTIAccount] = useState(false);
  const [isSeacrest, setIsSeacrest] = useState(false);
  useEffect(() => {
    console.log('SYMBOL SETTING: ', symbolSettings);
    console.log('magicFilter: ', symbolSettings?.additionalProps?.magicFilter);
    console.log('commentFilter: ', symbolSettings?.additionalProps?.commentFilter);
    if (symbolSettings && symbolSettings?.additionalProps?.magicFilter?.length > 0) {
      setSelectedMagicNumbers(symbolSettings?.additionalProps?.magicFilter.map((e: any) => e?.toString()));
    }
    if (symbolSettings && symbolSettings?.additionalProps?.commentFilter?.length > 0) {
      setSelectedComments(symbolSettings?.additionalProps?.commentFilter);
    }
  }, []);

  const [selectedMagicNumbers, setSelectedMagicNumbers] = useState<string[]>([]);
  const [selectedComments, setSelectedComments] = useState<string[]>([]);
  const [currentMagicNumber, setCurrentMagicNumber] = useState('');
  const [currentComment, setCurrentComment] = useState('');

  const getMagicFilters = (values: any) => {
    const magicFilters: Int64Value.AsObject[] =
      (values?.magicFilter === 'COPY' || values?.magicFilter === 'IGNORE') && selectedMagicNumbers
        ? selectedMagicNumbers
            .map((num: string) => parseFloat(num))
            .filter((num: number) => !isNaN(num))
            .map((num: number) => ({
              value: num
            }))
        : [];
    return magicFilters;
  };

  const getFilterComments = (values: any) => {
    const comments: StringValue.AsObject[] =
      (values?.filterByComment === 'COPY' || values?.filterByComment === 'IGNORE') && selectedComments
        ? selectedComments
            .filter((comment: string) => !!comment)
            .map((comment: string) => ({
              value: comment
            }))
        : [];
    return comments;
  };

  const getDelayType = (dto: SymbolSettingTableDto | null): string => {
    if (dto?.additionalProps?.tradeDelayMin && dto?.additionalProps?.tradeDelayMin !== dto?.additionalProps?.tradeDelayMax) {
      return 'random';
    } else if (
      dto?.additionalProps?.tradeDelayMin &&
      dto?.additionalProps?.tradeDelayMax &&
      dto?.additionalProps?.tradeDelayMin === dto?.additionalProps?.tradeDelayMax
    ) {
      return 'fixed';
    } else {
      return 'no';
    }
  };

  const getDelayTypeSlave = (dto: CopyTradingTableDto | null): string => {
    if (dto?.additionalProps?.tradeDelayMin && dto?.additionalProps?.tradeDelayMin !== dto?.additionalProps?.tradeDelayMax) {
      return 'random';
    } else if (
      dto?.additionalProps?.tradeDelayMin &&
      dto?.additionalProps?.tradeDelayMax &&
      dto?.additionalProps?.tradeDelayMin === dto?.additionalProps?.tradeDelayMax
    ) {
      return 'fixed';
    } else {
      return 'no';
    }
  };

  useEffect(() => {
    if (user && user?.tcId) {
      setApiCalling(true);
      const fetchingAccount = async () => {
        await fetchUserAccounts();
      };
      fetchingAccount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [accountList, setAccountList] = useState<AccountInfoLite.AsObject[]>([]);
  const fetchUserAccounts = async (cursor = '') => {
    try {
      const client = await accountClient();
      const req: AccountListReq.AsObject = {
        userId: user?.tcId || '',
        pageSize: 50,
        paginationCursor: cursor,
        query: ''
      };
      const res = await client.getAccountList(req);
      const result = res as AccountListReply.AsObject;
      setAccountList((prev) => [...prev, ...result.accountsList]);
      setApiCalling(false);
      if (result?.accountsList?.length === 50) {
        await fetchUserAccounts(result.nextPageCursor);
      }
    } catch (err) {
      console.log('ERROR: ', err);
      setApiCalling(false);
    }
  };

  useEffect(() => {
    const serverId = accountList.find(
      (e) => e.accountId === symbolSettings?.actualAccountId || e.accountId === selectedMasterAccountId
    )?.serverId;
    setIsCTIAccount(!!serverId && serverId === CTIServerID);
    setIsSeacrest(!!serverId && (serverId === SeacrestMT5ServerID || serverId === SeacrestMTRServerID));
  }, [accountList]);

  const isMTRMaster = () => {
    if (selectedMasterAccountId) {
      let tmpAccounts = cloneDeep(accountList);
      const copyFrom = tmpAccounts.find((e) => e.accountId === selectedMasterAccountId);
      console.log('selectedMaster: ', selectedMasterAccountId, tmpAccounts, copyFrom);

      return copyFrom && copyFrom?.platform === 'MTR';
    }
    return false;
  };

  const isTLMaster = () => {
    if (selectedMasterAccountId) {
      let tmpAccounts = cloneDeep(accountList);
      const copyFrom = tmpAccounts.find((e) => e.accountId === selectedMasterAccountId);
      console.log('selectedMaster: ', selectedMasterAccountId, tmpAccounts, copyFrom);

      return copyFrom && copyFrom?.platform === 'TL';
    }
    return false;
  };

  const hasTVAccount = () => {
    let hasTV = false;
    if (selectedMasterAccountId) {
      let tmpAccounts = cloneDeep(accountList);
      const copyFrom = tmpAccounts.find((e) => e.accountId === selectedMasterAccountId);
      if (copyFrom && copyFrom?.platform === 'TV') {
        hasTV = true;
      }
    }
    if (selectedSlave && selectedSlave.actualAccountId) {
      let tmpAccounts = cloneDeep(accountList);
      const copyTo = tmpAccounts.find((e) => e.accountId === selectedSlave.actualAccountId);
      if (copyTo && copyTo?.platform === 'TV') {
        hasTV = true;
      }
    }

    return hasTV;
  };

  const initialValues = React.useMemo(
    () =>
      isEdit
        ? {
            riskType: symbolSettings?.riskType ? riskTypeMapFromDisplayText[symbolSettings?.riskType] : '',
            directionType: symbolSettings?.settings?.allowedTradeSide?.value || 'ALL',
            masterSymbolName: symbolSettings ? symbolSettings.settings?.masterSymbol : '',
            slaveSymbolName: symbolSettings ? symbolSettings.settings?.symbol : '',
            riskSettings:
              symbolSettings?.riskType === 'Fixed Balance Multiplier'
                ? symbolSettings.settings?.fixedBalanceMultiplierValue?.value
                : Number(symbolSettings?.riskSetting?.slice(0, -1)),
            riskSettingsFixedLot: Number(symbolSettings?.riskSetting?.slice(0, -4)),
            riskSettingsBalancePercentage: symbolSettings?.settings?.balancePercentageValue?.value || '',
            copyTakeProfit: symbolSettings?.additionalProps?.copyTakeProfit || false,
            copyStopLoss: symbolSettings?.additionalProps?.copyStopLoss || false,
            copyPendingOrders: symbolSettings?.additionalProps?.copyPendingOrders || false,
            copyExistingTrades: symbolSettings?.additionalProps?.copyExistingTrades || false,
            forceMinimumLotSize: symbolSettings?.additionalProps?.forceMinimumLotSize || false,
            forceMaximumLotSize: symbolSettings?.additionalProps?.forceMaximumLotSize || false,
            reverseTrade: symbolSettings?.additionalProps?.reverseTrade || false,
            copyComment:
              symbolSettings?.additionalProps?.copyComment && symbolSettings?.additionalProps?.customComment
                ? 'Custom'
                : symbolSettings?.additionalProps?.copyComment
                ? 'Yes'
                : 'No',
            customComment: symbolSettings?.additionalProps?.customComment || '',
            strictClose: symbolSettings?.additionalProps?.strictClose || false,
            considerContractSize: symbolSettings?.additionalProps?.considerContractSize || false,
            copyMagicNumber:
              symbolSettings?.additionalProps?.copyMagicNumber &&
              symbolSettings?.additionalProps?.magicNumber &&
              symbolSettings?.additionalProps?.magicNumber !== '0'
                ? 'Custom'
                : symbolSettings?.additionalProps?.copyMagicNumber
                ? 'Yes'
                : 'No',
            magicNumber: symbolSettings?.additionalProps?.magicNumber || '',
            // status: symbolSettings?.status,
            fixedMasterBalance:
              symbolSettings?.riskType === 'Fixed Balance Multiplier' ? symbolSettings.settings?.fixedMasterBalance?.value?.toString() : '',
            lotRefiner: symbolSettings?.additionalProps?.lotRefiner,
            delayType: getDelayType(symbolSettings),
            tradeDelayMin: symbolSettings?.additionalProps?.tradeDelayMin || '',
            tradeDelayMax: symbolSettings?.additionalProps?.tradeDelayMax || '',
            magicFilter: symbolSettings?.settings?.magicFilterType ? symbolSettings?.settings?.magicFilterType?.value : 'UNKNOWN',
            magicFilterValue: '', // symbolSettings?.additionalProps?.magicFilter,
            copyExpiryTime: symbolSettings?.additionalProps?.copyExpiryTime || false,
            filterByComment: symbolSettings?.settings?.commentFilterType ? symbolSettings?.settings?.commentFilterType?.value : 'UNKNOWN',
            filterByCommentValue: '', // symbolSettings?.additionalProps?.commentFilter,
            filterByLotSize: symbolSettings?.additionalProps?.minLotFilter && symbolSettings?.additionalProps?.maxLotFilter ? 'Yes' : 'No',
            filterByLotSizeMinValue: symbolSettings?.additionalProps?.minLotFilter,
            filterByLotSizeMaxValue: symbolSettings?.additionalProps?.maxLotFilter,
            fixedStopLoss:
              !!symbolSettings?.additionalProps?.fixedStopLossValue && symbolSettings?.additionalProps?.fixedStopLossValue > 0
                ? 'Yes'
                : 'No',
            fixedStopLossValue: symbolSettings?.additionalProps?.fixedStopLossValue,
            fixedTakeProfit:
              !!symbolSettings?.additionalProps?.fixedTakeProfitValue && symbolSettings?.additionalProps?.fixedTakeProfitValue > 0
                ? 'Yes'
                : 'No',
            fixedTakeProfitValue: symbolSettings?.additionalProps?.fixedTakeProfitValue,
            stopLossRefinement:
              !!symbolSettings?.additionalProps?.stopLossRefinementValue && symbolSettings?.additionalProps?.stopLossRefinementValue != 0
                ? 'Yes'
                : 'No',
            stopLossRefinementValue: symbolSettings?.additionalProps?.stopLossRefinementValue,
            takeProfitRefinement:
              !!symbolSettings?.additionalProps?.takeProfitRefinementValue &&
              symbolSettings?.additionalProps?.takeProfitRefinementValue != 0
                ? 'Yes'
                : 'No',
            takeProfitRefinementValue: symbolSettings?.additionalProps?.takeProfitRefinementValue,
            submit: null
          }
        : {
            riskType: selectedSlave?.riskType ? riskTypeMapFromDisplayText[selectedSlave?.riskType] : '',
            directionType: selectedSlave?.slaveData?.allowedTradeSide?.value || 'ALL',
            masterSymbolName: '',
            slaveSymbolName: '',
            riskSettings:
              selectedSlave?.riskType === 'Fixed Balance Multiplier'
                ? selectedSlave.slaveData?.fixedBalanceMultiplierValue?.value
                : Number(selectedSlave?.riskSetting?.slice(0, -1)),
            riskSettingsFixedLot: Number(selectedSlave?.riskSetting?.slice(0, -4)),
            riskSettingsBalancePercentage: selectedSlave?.slaveData?.balancePercentageValue?.value || '',
            copyTakeProfit: selectedSlave?.additionalProps?.copyTakeProfit || false,
            copyStopLoss: selectedSlave?.additionalProps?.copyStopLoss || false,
            copyPendingOrders: selectedSlave?.additionalProps?.copyPendingOrders || false,
            copyExistingTrades: selectedSlave?.additionalProps?.copyExistingTrades || false,
            forceMinimumLotSize: selectedSlave?.additionalProps?.forceMinimumLotSize || false,
            forceMaximumLotSize: selectedSlave?.additionalProps?.forceMaximumLotSize || false,
            reverseTrade: selectedSlave?.additionalProps?.reverseTrade || false,
            copyComment:
              selectedSlave?.additionalProps?.copyComment && selectedSlave?.additionalProps?.customComment
                ? 'Custom'
                : selectedSlave?.additionalProps?.copyComment
                ? 'Yes'
                : 'No',
            customComment: selectedSlave?.additionalProps?.customComment || '',
            strictClose: selectedSlave?.additionalProps?.strictClose || false,
            considerContractSize: selectedSlave?.additionalProps?.considerContractSize || false,
            copyMagicNumber:
              selectedSlave?.additionalProps?.copyMagicNumber &&
              selectedSlave?.additionalProps?.magicNumber &&
              selectedSlave?.additionalProps?.magicNumber !== '0'
                ? 'Custom'
                : selectedSlave?.additionalProps?.copyMagicNumber
                ? 'Yes'
                : 'No',
            magicNumber: selectedSlave?.additionalProps?.magicNumber || '',
            // status: symbolSettings?.status,
            fixedMasterBalance:
              selectedSlave?.riskType === 'Fixed Balance Multiplier' ? selectedSlave.slaveData?.fixedMasterBalance?.value?.toString() : '',
            lotRefiner: selectedSlave?.additionalProps?.lotRefiner,
            delayType: getDelayTypeSlave(selectedSlave),
            tradeDelayMin: selectedSlave?.additionalProps?.tradeDelayMin || '',
            tradeDelayMax: selectedSlave?.additionalProps?.tradeDelayMax || '',
            magicFilter: selectedSlave?.slaveData?.magicFilterType ? selectedSlave?.slaveData?.magicFilterType.value : 'UNKNOWN',
            magicFilterValue: '', // selectedSlave?.additionalProps?.magicFilter,
            copyExpiryTime: selectedSlave?.additionalProps?.copyExpiryTime || false,
            filterByComment: selectedSlave?.slaveData?.commentFilterType ? selectedSlave?.slaveData?.commentFilterType.value : 'UNKNOWN',
            filterByCommentValue: '', // selectedSlave?.additionalProps?.commentFilter,
            filterByLotSize: selectedSlave?.additionalProps?.minLotFilter && selectedSlave?.additionalProps?.maxLotFilter ? 'Yes' : 'No',
            filterByLotSizeMinValue: selectedSlave?.additionalProps?.minLotFilter,
            filterByLotSizeMaxValue: selectedSlave?.additionalProps?.maxLotFilter,
            fixedStopLoss:
              !!selectedSlave?.additionalProps?.fixedStopLossValue && selectedSlave?.additionalProps?.fixedStopLossValue > 0 ? 'Yes' : 'No',
            fixedStopLossValue: selectedSlave?.additionalProps?.fixedStopLossValue,
            fixedTakeProfit:
              !!selectedSlave?.additionalProps?.fixedTakeProfitValue && selectedSlave?.additionalProps?.fixedTakeProfitValue > 0
                ? 'Yes'
                : 'No',
            fixedTakeProfitValue: selectedSlave?.additionalProps?.fixedTakeProfitValue,
            stopLossRefinement:
              !!selectedSlave?.additionalProps?.stopLossRefinementValue && selectedSlave?.additionalProps?.stopLossRefinementValue != 0
                ? 'Yes'
                : 'No',
            stopLossRefinementValue: selectedSlave?.additionalProps?.stopLossRefinementValue,
            takeProfitRefinement:
              !!selectedSlave?.additionalProps?.takeProfitRefinementValue && selectedSlave?.additionalProps?.takeProfitRefinementValue != 0
                ? 'Yes'
                : 'No',
            takeProfitRefinementValue: selectedSlave?.additionalProps?.takeProfitRefinementValue,
            submit: null
          },
    [symbolSettings]
  );

  const [formValues, setFormValues] = useState(initialValues);
  useEffect(() => {
    setFormValues({ ...initialValues });
  }, [initialValues]);

  const hasUnsavedChanges = (initialValues: any, values: any) => {
    const changes = Object.keys(initialValues)
      .filter((k) => k !== 'copyFrom')
      .some((key) => JSON.stringify(initialValues[key]) !== JSON.stringify(values[key]));
    return changes;
  };

  useEffect(() => {
    if (checkHasUnsaved) {
      const hasChanges = hasUnsavedChanges(initialValues, formValues);
      checkHasUnsaved(hasChanges);
    }
  }, [formValues, initialValues]);

  const formContent = (
    <Grid item xs={12}>
      <Formik
        initialValues={initialValues}
            validationSchema={Yup.object().shape({
              riskType: Yup.string().max(255).required('Risk type is required'),
              masterSymbolName: Yup.string().max(255).required('Master symbol is required'),
              slaveSymbolName: Yup.string().max(255).required('Slave symbol is required'),
              riskSettingsFixedLot: Yup.number()
                .moreThan(MIN_FIXED_LOT, 'Risk settings must be greater than ' + MIN_FIXED_LOT)
                .required('Risk settings value is required a valid number'),
              riskSettings: Yup.number()
                .typeError('Risk settings must be a valid number')
                .moreThan(MIN_RISK_SETTING, 'Risk settings must be greater than ' + MIN_RISK_SETTING)
                .required('Risk settings value is required a valid number'),
              riskSettingsBalancePercentage: Yup.number()
                .moreThan(0, 'Risk settings min value grater than 0')
                .max(100, 'Risk settings max value is 100')
                .required('Risk settings value is required a valid number'),
              fixedMasterBalance: Yup.number().min(0.01, 'Fixed master balance min value 0.01').required('Valid number required'),

              customComment: Yup.string().max(25, 'Maximum length of custom comment is 25'),
              magicNumber: Yup.number()
                .max(2147483647, 'Magic number range is 1 to 2147483647')
                .min(0, 'Magic number range is 1 to 2147483647')
                // .notOneOf([0], 'For 0 please set copy to No')
                .test('magicNumberNotZero', 'For 0 please set copy to No', (value: any, context: any) => {
                  const copyMagicNumber = context.parent.copyMagicNumber;
                  if (copyMagicNumber === 'No' || copyMagicNumber === 'Yes') {
                    return true;
                  }
                  return value !== 0;
                }),
              tradeDelayMin: Yup.number()
                .min(0, 'Minimum trade delay must be positive')
                .integer('Minimum trade delay must be integer')
                .test('minDelayRequired', 'Minimum trade delay is required', (value: any, context: any) => {
                  const delayType = context.parent.delayType;
                  if (delayType === 'no') {
                    return true;
                  }
                  return !!value;
                }),
              tradeDelayMax: Yup.number()
                .min(0, 'Maximum rade delay must be positive')
                .integer('Maximum rade delay must be integer')
                .test('maxMinDelayCheck', 'Max value must be greater than or equal to Min value', (value: any, context: any) => {
                  const delayType = context.parent.delayType;
                  if (delayType === 'no') {
                    return true;
                  }
                  const minValue = context.parent.tradeDelayMin;
                  console.log('minValue: ', minValue);
                  return value >= minValue;
                }),
              magicFilterValue: Yup.number()
                .max(2147483647, 'Magic filter range is 1 to 2147483647')
                .min(0, 'Magic filter range is 1 to 2147483647')
                // .notOneOf([0], 'For 0 please set magic filter to No'),
                .test('filterMagicValueNotZero', 'For 0 please set magic filter to No', (value: any, context: any) => {
                  const magicFilter = context.parent.magicFilter;
                  if (magicFilter === 'No') {
                    return true;
                  }
                  return value !== 0;
                }),
              filterByLotSizeMinValue: Yup.number().test(
                'filterByLotSizeMinValueMinimumCheck',
                'Minimum lot size value is 0.01',
                (value: any, context: any) => {
                  const filterByLotSize = context.parent.filterByLotSize;
                  if (filterByLotSize === 'No') {
                    return true;
                  }
                  return value >= 0.01;
                }
              ),
              filterByLotSizeMaxValue: Yup.number()
                // .min(0.02, 'Minimum lot size value is 0.02')
                .test('filterByLotSizeMaxValueMinimumCheck', 'Minimum lot size value is 0.02', (value: any, context: any) => {
                  const filterByLotSize = context.parent.filterByLotSize;
                  if (filterByLotSize === 'No') {
                    return true;
                  }
                  return value >= 0.02;
                })
                .test('maxMinCheck', 'Max value must be greater than or equal to Min value', (value: any, context: any) => {
                  const filterByLotSizeMinValue = context.parent.filterByLotSizeMinValue;
                  const filterByLotSize = context.parent.filterByLotSize;
                  if (filterByLotSize === 'No') {
                    return true;
                  }
                  console.log('filterByLotSizeMinValue: ', filterByLotSizeMinValue);
                  return value >= filterByLotSizeMinValue;
                }),
              fixedStopLossValue: Yup.number().when('fixedStopLoss', {
                is: (fixedStopLoss: any) => fixedStopLoss === 'Yes',
                then: Yup.number()
                  .required('Fixed stop loss is required')
                  .min(0, 'Fixed stop loss must be positive')
                  .notOneOf([0], 'For 0 please set fixed stop loss to No'),
                otherwise: Yup.number().nullable()
              }),
              fixedTakeProfitValue: Yup.number().when('fixedTakeProfit', {
                is: (fixedTakeProfit: any) => fixedTakeProfit === 'Yes',
                then: Yup.number()
                  .required('Fixed take profit is required')
                  .min(0, 'Fixed take profit must be positive')
                  .notOneOf([0], 'For 0 please set fixed take profit to No'),
                otherwise: Yup.number().nullable()
              }),
              stopLossRefinementValue: Yup.number().when('stopLossRefinement', {
                is: (stopLossRefinement: any) => stopLossRefinement === 'Yes',
                then: Yup.number()
                  .required('Stop loss refinement is required')
                  // .min(0, 'Stop loss refinement must be positive')
                  .notOneOf([0], 'For 0 please set stop loss refinement to No'),
                otherwise: Yup.number().nullable()
              }),
              takeProfitRefinementValue: Yup.number().when('takeProfitRefinement', {
                is: (takeProfitRefinement: any) => takeProfitRefinement === 'Yes',
                then: Yup.number()
                  .required('Take profit refinement is required')
                  // .min(0, 'Take profit refinement must be positive')
                  .notOneOf([0], 'For 0 please set take profit refinement to No'),
                otherwise: Yup.number().nullable()
              })
            })}
            onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {}}
          >
            {({ errors, handleBlur, handleChange, setFieldValue, handleSubmit, isSubmitting, touched, values }) => (
              <form noValidate onSubmit={handleSubmit}>
                <FormikEffect values={values} onChange={(values) => setFormValues(values)} />
                <Grid container spacing={3}>
                  <Grid item xs={12} sx={{ minHeight: '260px' }}>
                    {parseInt(values.riskType) === RISK_TYPE.BALANCE_PERCENTAGE && (
                      <Grid item xs={12} sx={{ paddingTop: '0px !important' }}>
                        <Alert color="warning" icon={<InfoCircleFilled />}>
                          Fixed percentage risk requires your master trades to contain a Stop Loss, without this trades will fail to copy.
                        </Alert>
                      </Grid>
                    )}
                    <Grid item xs={12} style={{ paddingTop: '12px' }}>
                      <Box
                        sx={{
                          '& .MuiAccordion-root': {
                            border: 'none',
                            '& .MuiAccordionSummary-root': {
                              bgcolor: 'transparent',
                              flexDirection: 'row',
                              padding: '0px',
                              '& .MuiAccordionSummary-content': {
                                marginLeft: '0px'
                              }
                            },
                            '& .MuiAccordionDetails-root': {
                              border: 'none',
                              padding: '16px 0px'
                            },
                            '& .Mui-expanded': {}
                          }
                        }}
                      >
                        <Accordion expanded={copyExpanded}>
                          <Grid>
                            <AccordionSummary
                              expandIcon={<CaretRightFilled />}
                              onClick={(e) => {
                                if (!copyExpanded) {
                                  setCopyExpanded(true);
                                  setSlTpExpand(false);
                                  setFilterExpanded(false);
                                  setAdvanceExpanded(false);
                                }
                              }}
                            >
                              <Typography variant={'subtitle1'}>Risk Settings</Typography>
                            </AccordionSummary>
                            <Divider />
                          </Grid>
                          <AccordionDetails>
                            <Grid container spacing={3}>
                              <Grid item xs={12}>
                                <Grid item xs={12} display={'flex'} sx={{ mb: 2 }}>
                                  <Grid item xs={12}>
                                    <Stack spacing={1}>
                                      <FormControl fullWidth>
                                        <SymbolAutocompleteWrapperUpdated
                                          id={'slaveSymbolName'}
                                          label={'Slave Symbol*'}
                                          disabled={!!symbolSettings}
                                          error={Boolean(touched.slaveSymbolName && errors.slaveSymbolName)}
                                          defaultValue={values.slaveSymbolName || ''}
                                          selectedAccountId={selectedSlave?.actualAccountId || ''}
                                          onOptionSelect={async (value) => {
                                            if (value && value.name) {
                                              fetchMasterSymbol(value.name);
                                              setFieldValue('slaveSymbolName', value.name);
                                            } else {
                                              setFieldValue('slaveSymbolName', '');
                                              setCurrentMasterSymbol('');
                                            }
                                          }}
                                        />
                                      </FormControl>
                                      {touched.slaveSymbolName && errors.slaveSymbolName && (
                                        <FormHelperText error id="helper-text-slaveSymbolName">
                                          {errors.slaveSymbolName}
                                        </FormHelperText>
                                      )}
                                    </Stack>
                                  </Grid>

                                  {!currentMasterSymbol && !loadingMasterSymbol && values.slaveSymbolName && (
                                    <Grid item xs={12} sx={{ ml: 2 }}>
                                      <Stack spacing={1}>
                                        <FormControl fullWidth>
                                          <SymbolAutocompleteWrapperUpdated
                                            disabled={!!symbolSettings}
                                            id={'masterSymbolName'}
                                            label={'Master Symbol*'}
                                            error={Boolean(touched.masterSymbolName && errors.masterSymbolName)}
                                            selectedAccountId={selectedMasterAccountId}
                                            defaultValue={values.masterSymbolName || ''}
                                            onOptionSelect={async (value) => {
                                              if (value && value.name) {
                                                setFieldValue('masterSymbolName', value.name);
                                              } else {
                                                setFieldValue('masterSymbolName', '');
                                              }
                                            }}
                                          />
                                        </FormControl>
                                        {touched.masterSymbolName && errors.masterSymbolName && (
                                          <FormHelperText error id="helper-text-masterSymbolName">
                                            {errors.masterSymbolName}
                                          </FormHelperText>
                                        )}
                                      </Stack>
                                    </Grid>
                                  )}
                                </Grid>
                                <Grid item xs={12} display={'flex'}>
                                  <Grid sx={{ mr: 2 }} item xs={12}>
                                    <Stack spacing={1}>
                                      <FormControl fullWidth>
                                        <InputLabel
                                          style={{ minHeight: '14px', lineHeight: '12px' }}
                                          error={Boolean(touched.riskType && errors.riskType)}
                                          id="risk-type"
                                        >
                                          Risk Type
                                        </InputLabel>
                                        <Select
                                          labelId="risk-type"
                                          id="risk-type"
                                          name="riskType"
                                          placeholder="Risk Type"
                                          value={values.riskType}
                                          onBlur={handleBlur}
                                          onChange={(event, value) => {
                                            console.log(event?.target?.value);
                                            if (
                                              +event?.target?.value === RISK_TYPE.FIXED_BALANCE_MULTIPLIER ||
                                              +event?.target?.value === RISK_TYPE.BALANCE_MULTIPLIER
                                            ) {
                                              setFieldValue('considerContractSize', true);
                                            } else {
                                              setFieldValue('considerContractSize', false);
                                            }
                                            setFieldValue('riskType', event?.target?.value);
                                            setFieldValue('riskSettingsFixedLot', '');
                                            setFieldValue('riskSettings', '');
                                            setFieldValue('fixedMasterBalance', '');
                                          }}
                                          error={Boolean(touched.riskType && errors.riskType)}
                                        >
                                          <MenuItem value={RISK_TYPE.FIXED_LOT}>Fixed Lot</MenuItem>
                                          <MenuItem value={RISK_TYPE.LOT_MULTIPLIER}>Lot Multiplier</MenuItem>
                                          <MenuItem value={RISK_TYPE.BALANCE_MULTIPLIER}>Balance Multiplier</MenuItem>
                                          <MenuItem value={RISK_TYPE.FIXED_BALANCE_MULTIPLIER}>Fixed Balance Multiplier</MenuItem>
                                          {!isTLMaster() && <MenuItem value={RISK_TYPE.BALANCE_PERCENTAGE}>Fixed % risk</MenuItem>}
                                        </Select>
                                      </FormControl>
                                      {touched.riskType && errors.riskType && (
                                        <FormHelperText error id="helper-text-risk-type">
                                          {errors.riskType}
                                        </FormHelperText>
                                      )}
                                    </Stack>
                                  </Grid>
                                  {parseInt(values.riskType) === RISK_TYPE.FIXED_BALANCE_MULTIPLIER && (
                                    <>
                                      <Grid sx={{ mr: 2 }} item xs={12}>
                                        <Stack spacing={1}>
                                          <FormControl variant="outlined">
                                            <InputLabel sx={{ minHeight: '14px', lineHeight: '12px' }} htmlFor="fixedMasterBalance">
                                              Fixed Master Balance
                                            </InputLabel>
                                            <OutlinedInput
                                              fullWidth
                                              error={Boolean(touched.fixedMasterBalance && errors.fixedMasterBalance)}
                                              label={'Fixed Master Balance'}
                                              inputProps={{ style: { minHeight: '14px', lineHeight: '12px' } }}
                                              id="fixedMasterBalance"
                                              type="number"
                                              value={values.fixedMasterBalance}
                                              name="fixedMasterBalance"
                                              onBlur={handleBlur}
                                              onChange={handleChange}
                                              placeholder="Fixed Master Balance"
                                              endAdornment={<InputAdornment position="end">$</InputAdornment>}
                                            />
                                          </FormControl>
                                          {touched.fixedMasterBalance && errors.fixedMasterBalance && (
                                            <FormHelperText error id="helper-text-fixedMasterBalance">
                                              {errors.fixedMasterBalance}
                                            </FormHelperText>
                                          )}
                                        </Stack>
                                      </Grid>
                                      <Grid item xs={12}>
                                        <Stack spacing={1}>
                                          <FormControl variant="outlined">
                                            <InputLabel sx={{ minHeight: '14px', lineHeight: '12px' }} htmlFor="risk-settings">
                                              Risk Setting
                                            </InputLabel>
                                            <OutlinedInput
                                              fullWidth
                                              error={Boolean(touched.riskSettings && errors.riskSettings)}
                                              label={'Risk Setting'}
                                              inputProps={{ style: { minHeight: '14px', lineHeight: '12px' } }}
                                              id="risk-settings"
                                              type="number"
                                              value={values.riskSettings}
                                              name="riskSettings"
                                              onBlur={handleBlur}
                                              onChange={handleChange}
                                              placeholder="Risk Setting"
                                              endAdornment={<InputAdornment position="end">%</InputAdornment>}
                                            />
                                          </FormControl>
                                          {touched.riskSettings && errors.riskSettings && (
                                            <FormHelperText error id="helper-text-risk-settings">
                                              {errors.riskSettings}
                                            </FormHelperText>
                                          )}
                                        </Stack>
                                      </Grid>
                                    </>
                                  )}
                                  {(parseInt(values.riskType) === RISK_TYPE.LOT_MULTIPLIER ||
                                    parseInt(values.riskType) === RISK_TYPE.BALANCE_MULTIPLIER ||
                                    values.riskType === '') && (
                                    <Grid item xs={12}>
                                      <Stack spacing={1}>
                                        <FormControl variant="outlined">
                                          <InputLabel sx={{ minHeight: '14px', lineHeight: '12px' }} htmlFor="risk-settings">
                                            Risk Setting - 100% = 1 to 1 risk
                                          </InputLabel>
                                          <OutlinedInput
                                            fullWidth
                                            error={Boolean(touched.riskSettings && errors.riskSettings)}
                                            label={'Risk Setting - 100% = 1 to 1 risk'}
                                            inputProps={{ style: { minHeight: '14px', lineHeight: '12px' } }}
                                            id="risk-settings"
                                            type="number"
                                            value={values.riskSettings}
                                            name="riskSettings"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            placeholder="Risk Setting - 100% = 1 to 1 risk"
                                            endAdornment={<InputAdornment position="end">%</InputAdornment>}
                                          />
                                        </FormControl>
                                        {touched.riskSettings && errors.riskSettings && (
                                          <FormHelperText error id="helper-text-risk-settings">
                                            {errors.riskSettings}
                                          </FormHelperText>
                                        )}
                                      </Stack>
                                    </Grid>
                                  )}
                                  {parseInt(values.riskType) === RISK_TYPE.FIXED_LOT && (
                                    <Grid item xs={12}>
                                      <Stack spacing={1}>
                                        <FormControl variant="outlined">
                                          <InputLabel sx={{ minHeight: '14px', lineHeight: '12px' }} htmlFor="risk-settings-fixed-lot">
                                            Lot Size
                                          </InputLabel>
                                          <OutlinedInput
                                            fullWidth
                                            error={Boolean(touched.riskSettingsFixedLot && errors.riskSettingsFixedLot)}
                                            label={'Lot Size'}
                                            inputProps={{
                                              style: { minHeight: '14px', lineHeight: '12px' },
                                              step: hasTVAccount() ? '1' : '0.01'
                                            }}
                                            id="risk-settings-fixed-lot"
                                            type="number"
                                            value={values.riskSettingsFixedLot}
                                            name="riskSettingsFixedLot"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                              if (hasTVAccount()) {
                                                const value = e.target.value;
                                                if (value.includes('.')) {
                                                  // If decimal is entered, round it to nearest integer
                                                  e.target.value = Math.round(parseFloat(value)).toString();
                                                }
                                              }
                                              handleChange(e);
                                            }}
                                            placeholder="Lot Size"
                                          />
                                        </FormControl>
                                        {touched.riskSettingsFixedLot && errors.riskSettingsFixedLot && (
                                          <FormHelperText error id="helper-text-risk-settings-fixed-lot">
                                            Lot size is required a valid number
                                          </FormHelperText>
                                        )}
                                      </Stack>
                                    </Grid>
                                  )}
                                  {parseInt(values.riskType) === RISK_TYPE.BALANCE_PERCENTAGE && (
                                    <Grid item xs={12}>
                                      <Stack spacing={1}>
                                        <FormControl variant="outlined">
                                          <InputLabel
                                            sx={{ minHeight: '14px', lineHeight: '12px' }}
                                            htmlFor="risk-settings-BALANCE_PERCENTAGE"
                                          >
                                            Balance percentage
                                          </InputLabel>
                                          <OutlinedInput
                                            fullWidth
                                            error={Boolean(touched.riskSettingsBalancePercentage && errors.riskSettingsBalancePercentage)}
                                            label={'Balance percentage'}
                                            inputProps={{ style: { minHeight: '14px', lineHeight: '12px' } }}
                                            id="risk-settings-BALANCE_PERCENTAGE"
                                            type="number"
                                            value={values.riskSettingsBalancePercentage}
                                            name="riskSettingsBalancePercentage"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            placeholder="Balance percentage"
                                          />
                                        </FormControl>
                                        {touched.riskSettingsBalancePercentage && errors.riskSettingsBalancePercentage && (
                                          <FormHelperText error id="helper-text-risk-settings-fixed-lot">
                                            Balance percentage is required a valid number
                                          </FormHelperText>
                                        )}
                                      </Stack>
                                    </Grid>
                                  )}
                                </Grid>
                              </Grid>
                              {/*<Divider sx={{ width: '96%', ml: 3, mr: 3 }} />*/}
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      </Box>
                    </Grid>

                    <Grid item xs={12} style={{ paddingTop: '12px' }}>
                      <Box
                        sx={{
                          '& .MuiAccordion-root': {
                            border: 'none',
                            '& .MuiAccordionSummary-root': {
                              bgcolor: 'transparent',
                              flexDirection: 'row',
                              padding: '0px',
                              '& .MuiAccordionSummary-content': {
                                marginLeft: '0px'
                              }
                            },
                            '& .MuiAccordionDetails-root': {
                              border: 'none',
                              padding: '16px 0px'
                            },
                            '& .Mui-expanded': {}
                          }
                        }}
                      >
                        <Accordion expanded={slTpExpand}>
                          <Grid>
                            <AccordionSummary
                              expandIcon={<CaretRightFilled />}
                              onClick={(e) => {
                                if (!slTpExpand) {
                                  setCopyExpanded(false);
                                  setSlTpExpand(true);
                                  setFilterExpanded(false);
                                  setAdvanceExpanded(false);
                                }
                              }}
                            >
                              <Typography variant={'subtitle1'}>SL and TP Settings</Typography>
                            </AccordionSummary>
                            <Divider />
                          </Grid>
                          <AccordionDetails>
                            <Grid item xs={12} display={'flex'}>
                              <Grid item xs={4}>
                                <FormControlLabel
                                  value="start"
                                  control={
                                    <Checkbox
                                      name="copyStopLoss"
                                      disabled={values?.strictClose}
                                      checked={values.copyStopLoss}
                                      onChange={(event, checked) => {
                                        if (!checked) {
                                          setFieldValue('stopLossRefinement', 'No');
                                          setFieldValue('stopLossRefinementValue', '');
                                        } else {
                                          setFieldValue('fixedStopLoss', 'No');
                                          setFieldValue('fixedStopLossValue', '');
                                        }
                                        setFieldValue('copyStopLoss', checked);
                                      }}
                                    />
                                  }
                                  label="Copy Stop Loss"
                                  labelPlacement="end"
                                  sx={{ ml: 1, mr: 1 }}
                                />
                              </Grid>
                              <Grid item xs={4}>
                                <FormControlLabel
                                  value="start"
                                  control={
                                    <Checkbox
                                      name="copyTakeProfit"
                                      disabled={values?.strictClose}
                                      checked={values.copyTakeProfit}
                                      onChange={(event, checked) => {
                                        setFieldValue('copyTakeProfit', checked);
                                        if (!checked) {
                                          setFieldValue('takeProfitRefinement', 'No');
                                          setFieldValue('takeProfitRefinementValue', '');
                                        } else {
                                          setFieldValue('fixedTakeProfit', 'No');
                                          setFieldValue('fixedTakeProfitValue', '');
                                        }
                                      }}
                                    />
                                  }
                                  label="Copy Take Profit"
                                  labelPlacement="end"
                                  sx={{ ml: 1, mr: 1 }}
                                />
                              </Grid>
                              <Grid item xs={4}>
                                {(isMTRMaster() || hasTVAccount()) && (
                                  <Tooltip
                                    title={
                                      <Typography
                                        color={
                                          theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.typography.caption.color
                                        }
                                        variant={'caption'}
                                      >
                                        {!hasTVAccount()
                                          ? 'Not currently available for MatchTrader masters, trades will execute when the master order fills'
                                          : 'Not currently available for Tradovate, trades will execute when the master order fills'}
                                      </Typography>
                                    }
                                  >
                                    <FormControlLabel
                                      value="start"
                                      control={
                                        <Checkbox
                                          name="copyPendingOrders"
                                          disabled={values.reverseTrade || isMTRMaster() || hasTVAccount()}
                                          checked={values.copyPendingOrders}
                                          // onChange={handleChange}
                                        />
                                      }
                                      label="Copy Pending Orders"
                                      labelPlacement="end"
                                      sx={{ ml: 1, mr: 1 }}
                                    />
                                  </Tooltip>
                                )}
                                {!(isMTRMaster() || hasTVAccount()) && (
                                  <FormControlLabel
                                    value="start"
                                    control={
                                      <Checkbox
                                        name="copyPendingOrders"
                                        disabled={values.reverseTrade}
                                        checked={values.copyPendingOrders}
                                        onChange={handleChange}
                                      />
                                    }
                                    label="Copy Pending Orders"
                                    labelPlacement="end"
                                    sx={{ ml: 1, mr: 1 }}
                                  />
                                )}
                              </Grid>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 3 }} justifyContent={'space-between'} display={'flex'}>
                              <Grid sx={{ mr: 2 }} item xs={6}>
                                <Stack spacing={1}>
                                  <Tooltip
                                    title={
                                      !values?.copyStopLoss ? (
                                        ''
                                      ) : (
                                        <Typography
                                          color={
                                            theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.typography.caption.color
                                          }
                                          variant={'caption'}
                                        >
                                          Remove copy stop loss first
                                        </Typography>
                                      )
                                    }
                                  >
                                    <FormControl fullWidth>
                                      <InputLabel
                                        style={{ minHeight: '14px', lineHeight: '12px' }}
                                        error={Boolean(touched.fixedStopLoss && errors.fixedStopLoss)}
                                        id="fixedStopLoss"
                                      >
                                        Fixed Stop Loss (pips)
                                      </InputLabel>
                                      <Select
                                        labelId="fixedStopLoss"
                                        id="fixedStopLoss"
                                        name="fixedStopLoss"
                                        placeholder="Fixed Stop Loss"
                                        value={values.fixedStopLoss}
                                        onBlur={handleBlur}
                                        onChange={(e, v) => {
                                          setFieldValue('fixedStopLoss', e?.target?.value);
                                          setFieldValue('fixedStopLossValue', '');
                                          if (e?.target?.value === 'Yes' && values.copyStopLoss && values.strictClose) {
                                            setFieldValue('copyStopLoss', false);
                                          } else if (e?.target?.value === 'No' && !values.copyStopLoss && values.strictClose) {
                                            setFieldValue('copyStopLoss', true);
                                          }
                                        }}
                                        disabled={values.copyStopLoss && !values.strictClose}
                                        error={Boolean(touched.fixedStopLoss && errors.fixedStopLoss)}
                                      >
                                        <MenuItem value={'No'}>No</MenuItem>
                                        <MenuItem value={'Yes'}>Yes</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Tooltip>
                                  {touched.fixedStopLoss && errors.fixedStopLoss && (
                                    <FormHelperText error id="helper-text-fixedStopLoss">
                                      {errors.fixedStopLoss}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                              <Grid item xs={6}>
                                <Stack spacing={1}>
                                  <FormControl variant="outlined">
                                    <InputLabel
                                      error={Boolean(touched.fixedStopLossValue && errors.fixedStopLossValue)}
                                      disabled={values.fixedStopLoss !== 'Yes'}
                                      sx={{ minHeight: '14px', lineHeight: '12px' }}
                                      htmlFor="fixedStopLossValue"
                                    >
                                      Enter Fixed Stop Loss
                                    </InputLabel>
                                    <OutlinedInput
                                      fullWidth
                                      error={Boolean(touched.fixedStopLossValue && errors.fixedStopLossValue)}
                                      label={'Enter Fixed Stop Loss'}
                                      inputProps={{ style: { minHeight: '14px', lineHeight: '12px' } }}
                                      id="fixedStopLossValue"
                                      type="number"
                                      value={values?.fixedStopLoss === 'Yes' ? values.fixedStopLossValue : ''}
                                      name="fixedStopLossValue"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      placeholder="Enter Fixed Stop Loss"
                                      disabled={(values.fixedStopLoss !== 'Yes' || values.copyStopLoss) && !values.strictClose}
                                      readOnly={(values.fixedStopLoss !== 'Yes' || values.copyStopLoss) && !values.strictClose}
                                    />
                                  </FormControl>
                                  {touched.fixedStopLossValue && errors.fixedStopLossValue && (
                                    <FormHelperText error id="helper-text-fixedStopLossValue">
                                      {errors.fixedStopLossValue}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 3 }} justifyContent={'space-between'} display={'flex'}>
                              <Grid sx={{ mr: 2 }} item xs={6}>
                                <Stack spacing={1}>
                                  <Tooltip
                                    title={
                                      !values?.copyTakeProfit ? (
                                        ''
                                      ) : (
                                        <Typography
                                          color={
                                            theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.typography.caption.color
                                          }
                                          variant={'caption'}
                                        >
                                          Remove copy take profit first
                                        </Typography>
                                      )
                                    }
                                  >
                                    <FormControl fullWidth>
                                      <InputLabel
                                        style={{ minHeight: '14px', lineHeight: '12px' }}
                                        error={Boolean(touched.fixedTakeProfit && errors.fixedTakeProfit)}
                                        id="fixedTakeProfit"
                                      >
                                        Fixed Take Profit (pips)
                                      </InputLabel>
                                      <Select
                                        labelId="fixedTakeProfit"
                                        id="fixedTakeProfit"
                                        name="fixedTakeProfit"
                                        placeholder="Fixed Take Profit"
                                        value={values.fixedTakeProfit}
                                        onBlur={handleBlur}
                                        onChange={(e, v) => {
                                          setFieldValue('fixedTakeProfit', e?.target?.value);
                                          setFieldValue('fixedTakeProfitValue', '');
                                          if (e?.target?.value === 'Yes' && values.copyTakeProfit && values.strictClose) {
                                            setFieldValue('copyTakeProfit', false);
                                          } else if (e?.target?.value === 'No' && !values.copyTakeProfit && values.strictClose) {
                                            setFieldValue('copyTakeProfit', true);
                                          }
                                        }}
                                        disabled={values.copyTakeProfit && !values.strictClose}
                                        error={Boolean(touched.fixedTakeProfit && errors.fixedTakeProfit)}
                                      >
                                        <MenuItem value={'No'}>No</MenuItem>
                                        <MenuItem value={'Yes'}>Yes</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Tooltip>
                                  {touched.fixedTakeProfit && errors.fixedTakeProfit && (
                                    <FormHelperText error id="helper-text-fixedTakeProfit">
                                      {errors.fixedTakeProfit}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                              <Grid item xs={6}>
                                <Stack spacing={1}>
                                  <FormControl variant="outlined">
                                    <InputLabel
                                      error={Boolean(touched.fixedTakeProfitValue && errors.fixedTakeProfitValue)}
                                      disabled={values.fixedTakeProfit !== 'Yes'}
                                      sx={{ minHeight: '14px', lineHeight: '12px' }}
                                      htmlFor="fixedTakeProfit"
                                    >
                                      Enter Fixed Take Profit
                                    </InputLabel>
                                    <OutlinedInput
                                      fullWidth
                                      error={Boolean(touched.fixedTakeProfitValue && errors.fixedTakeProfitValue)}
                                      label={'Enter Fixed Take Profit'}
                                      inputProps={{ style: { minHeight: '14px', lineHeight: '12px' } }}
                                      id="fixedTakeProfitValue"
                                      type="number"
                                      value={values?.fixedTakeProfit === 'Yes' ? values.fixedTakeProfitValue : ''}
                                      name="fixedTakeProfitValue"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      placeholder="Enter Fixed Take Profit"
                                      disabled={(values.fixedTakeProfit !== 'Yes' || values.copyTakeProfit) && !values.strictClose}
                                      readOnly={(values.fixedTakeProfit !== 'Yes' || values.copyTakeProfit) && !values.strictClose}
                                    />
                                  </FormControl>
                                  {touched.fixedTakeProfitValue && errors.fixedTakeProfitValue && (
                                    <FormHelperText error id="helper-text-fixedTakeProfitValue">
                                      {errors.fixedTakeProfitValue}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 3 }} justifyContent={'space-between'} display={'flex'}>
                              <Grid sx={{ mr: 2 }} item xs={6}>
                                <Stack spacing={1}>
                                  <Tooltip
                                    title={
                                      values?.copyStopLoss ? (
                                        ''
                                      ) : (
                                        <Typography
                                          color={
                                            theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.typography.caption.color
                                          }
                                          variant={'caption'}
                                        >
                                          Select copy stop loss first
                                        </Typography>
                                      )
                                    }
                                  >
                                    <FormControl fullWidth>
                                      <InputLabel
                                        style={{ minHeight: '14px', lineHeight: '12px' }}
                                        error={Boolean(touched.stopLossRefinement && errors.stopLossRefinement)}
                                        id="stopLossRefinement"
                                      >
                                        Stop Loss Refinement (pips)
                                      </InputLabel>
                                      <Select
                                        labelId="stopLossRefinement"
                                        id="stopLossRefinement"
                                        name="stopLossRefinement"
                                        placeholder="Stop Loss Refinement"
                                        value={values.stopLossRefinement}
                                        onBlur={handleBlur}
                                        onChange={(e, v) => {
                                          setFieldValue('stopLossRefinement', e?.target?.value);
                                          setFieldValue('stopLossRefinementValue', '');
                                        }}
                                        disabled={!values.copyStopLoss}
                                        error={Boolean(touched.stopLossRefinement && errors.stopLossRefinement)}
                                      >
                                        <MenuItem value={'No'}>No</MenuItem>
                                        <MenuItem value={'Yes'}>Yes</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Tooltip>
                                  {touched.stopLossRefinement && errors.stopLossRefinement && (
                                    <FormHelperText error id="helper-text-stopLossRefinement">
                                      {errors.stopLossRefinement}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                              <Grid item xs={6}>
                                <Stack spacing={1}>
                                  <FormControl variant="outlined">
                                    <InputLabel
                                      error={Boolean(touched.stopLossRefinementValue && errors.stopLossRefinementValue)}
                                      disabled={values.stopLossRefinement !== 'Yes'}
                                      sx={{ minHeight: '14px', lineHeight: '12px' }}
                                      htmlFor="stopLossRefinementValue"
                                    >
                                      Enter Refinement
                                    </InputLabel>
                                    <OutlinedInput
                                      fullWidth
                                      error={Boolean(touched.stopLossRefinementValue && errors.stopLossRefinementValue)}
                                      label={'Enter Refinement'}
                                      inputProps={{ style: { minHeight: '14px', lineHeight: '12px' } }}
                                      id="stopLossRefinementValue"
                                      type="number"
                                      value={values?.stopLossRefinement === 'Yes' ? values.stopLossRefinementValue : ''}
                                      name="stopLossRefinementValue"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      placeholder="Enter Refinement"
                                      disabled={values.stopLossRefinement !== 'Yes' || !values.copyStopLoss}
                                      readOnly={values.stopLossRefinement !== 'Yes' || !values.copyStopLoss}
                                    />
                                  </FormControl>
                                  {touched.stopLossRefinementValue && errors.stopLossRefinementValue && (
                                    <FormHelperText error id="helper-text-stopLossRefinementValue">
                                      {errors.stopLossRefinementValue}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 3 }} justifyContent={'space-between'} display={'flex'}>
                              <Grid sx={{ mr: 2 }} item xs={6}>
                                <Stack spacing={1}>
                                  <Tooltip
                                    title={
                                      values?.copyTakeProfit ? (
                                        ''
                                      ) : (
                                        <Typography
                                          color={
                                            theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.typography.caption.color
                                          }
                                          variant={'caption'}
                                        >
                                          Select copy take profit first
                                        </Typography>
                                      )
                                    }
                                  >
                                    <FormControl fullWidth>
                                      <InputLabel
                                        style={{ minHeight: '14px', lineHeight: '12px' }}
                                        error={Boolean(touched.takeProfitRefinement && errors.takeProfitRefinement)}
                                        id="takeProfitRefinement"
                                      >
                                        Take Profit Refinement (pips)
                                      </InputLabel>
                                      <Select
                                        labelId="takeProfitRefinement"
                                        id="takeProfitRefinement"
                                        name="takeProfitRefinement"
                                        placeholder="Take Profit Refinement"
                                        value={values.takeProfitRefinement}
                                        onBlur={handleBlur}
                                        onChange={(e, v) => {
                                          setFieldValue('takeProfitRefinement', e?.target?.value);
                                          setFieldValue('takeProfitRefinementValue', '');
                                        }}
                                        disabled={!values.copyTakeProfit}
                                        error={Boolean(touched.takeProfitRefinement && errors.takeProfitRefinement)}
                                      >
                                        <MenuItem value={'No'}>No</MenuItem>
                                        <MenuItem value={'Yes'}>Yes</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Tooltip>
                                  {touched.takeProfitRefinement && errors.takeProfitRefinement && (
                                    <FormHelperText error id="helper-text-takeProfitRefinement">
                                      {errors.takeProfitRefinement}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                              <Grid item xs={6}>
                                <Stack spacing={1}>
                                  <FormControl variant="outlined">
                                    <InputLabel
                                      error={Boolean(touched.takeProfitRefinementValue && errors.takeProfitRefinementValue)}
                                      disabled={values.takeProfitRefinement !== 'Yes'}
                                      sx={{ minHeight: '14px', lineHeight: '12px' }}
                                      htmlFor="takeProfitRefinementValue"
                                    >
                                      Enter Refinement
                                    </InputLabel>
                                    <OutlinedInput
                                      fullWidth
                                      error={Boolean(touched.takeProfitRefinementValue && errors.takeProfitRefinementValue)}
                                      label={'Enter Refinement'}
                                      inputProps={{ style: { minHeight: '14px', lineHeight: '12px' } }}
                                      id="takeProfitRefinementValue"
                                      type="number"
                                      value={values?.takeProfitRefinement === 'Yes' ? values.takeProfitRefinementValue : ''}
                                      name="takeProfitRefinementValue"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      placeholder="Enter Refinement"
                                      disabled={values.takeProfitRefinement !== 'Yes' || !values.copyTakeProfit}
                                      readOnly={values.takeProfitRefinement !== 'Yes' || !values.copyTakeProfit}
                                    />
                                  </FormControl>
                                  {touched.takeProfitRefinementValue && errors.takeProfitRefinementValue && (
                                    <FormHelperText error id="helper-text-takeProfitRefinementValue">
                                      {errors.takeProfitRefinementValue}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      </Box>
                    </Grid>

                    <Grid item xs={12} style={{ paddingTop: '12px' }}>
                      <Box
                        sx={{
                          '& .MuiAccordion-root': {
                            border: 'none',
                            '& .MuiAccordionSummary-root': {
                              bgcolor: 'transparent',
                              flexDirection: 'row',
                              padding: '0px',
                              '& .MuiAccordionSummary-content': {
                                marginLeft: '0px'
                              }
                            },
                            '& .MuiAccordionDetails-root': {
                              border: 'none',
                              padding: '16px 0px'
                            },
                            '& .Mui-expanded': {}
                          }
                        }}
                      >
                        <Accordion expanded={advanceExpanded}>
                          <Grid>
                            <AccordionSummary
                              expandIcon={<CaretRightFilled />}
                              onClick={(e) => {
                                if (!advanceExpanded) {
                                  setAdvanceExpanded(true);
                                  setSlTpExpand(false);
                                  setFilterExpanded(false);
                                  setCopyExpanded(false);
                                }
                              }}
                            >
                              <Typography variant={'subtitle1'}>Advanced Settings</Typography>
                            </AccordionSummary>
                            <Divider />
                          </Grid>

                          <AccordionDetails>
                            <Grid item xs={12} display={'flex'}>
                              <Grid item xs={4}>
                                <FormControlLabel
                                  value="start"
                                  control={
                                    <Checkbox name="forceMinimumLotSize" checked={values.forceMinimumLotSize} onChange={handleChange} />
                                  }
                                  label="Force Minimum Lot Size"
                                  labelPlacement="end"
                                  sx={{ ml: 1, mr: 1 }}
                                />
                              </Grid>
                              <Grid item xs={4}>
                                <FormControlLabel
                                  value="start"
                                  control={
                                    <Checkbox name="forceMaximumLotSize" checked={values.forceMaximumLotSize} onChange={handleChange} />
                                  }
                                  label="Force Maximum Lot Size"
                                  labelPlacement="end"
                                  sx={{ mr: 1 }}
                                />
                              </Grid>
                              <Grid item xs={4}>
                                {(isCTIAccount || isSeacrest) && (
                                  <Tooltip
                                    title={
                                      <Typography
                                        color={
                                          theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.typography.caption.color
                                        }
                                        variant={'caption'}
                                      >
                                        {isSeacrest ? 'Seacrest Markets' : 'CTI'} does not allow this feature
                                      </Typography>
                                    }
                                  >
                                    <FormControlLabel
                                      value="start"
                                      control={
                                        <Checkbox name="reverseTrade" disabled={isCTIAccount || isSeacrest} checked={values.reverseTrade} />
                                      }
                                      label="Reverse Trade"
                                      labelPlacement="end"
                                      sx={{ mr: 1 }}
                                    />
                                  </Tooltip>
                                )}
                                {!(isCTIAccount || isSeacrest) && (
                                  <FormControlLabel
                                    value="start"
                                    control={
                                      <Checkbox
                                        name="reverseTrade"
                                        checked={values.reverseTrade}
                                        onChange={(e, value) => {
                                          setFieldValue('reverseTrade', value);
                                          if (value) {
                                            setFieldValue('copyPendingOrders', false);
                                          }
                                        }}
                                      />
                                    }
                                    label="Reverse Trade"
                                    labelPlacement="end"
                                    sx={{ mr: 1 }}
                                  />
                                )}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} style={{ paddingTop: '12px' }} display={'flex'}>
                              <Grid item xs={4}>
                                <FormControlLabel
                                  value="start"
                                  control={
                                    <Checkbox
                                      name="considerContractSize"
                                      checked={values.considerContractSize}
                                      disabled={+values.riskType === RISK_TYPE.BALANCE_PERCENTAGE}
                                      onChange={(e, value) => {
                                        setFieldValue('considerContractSize', value);
                                        // if (value) {
                                        //   setFieldValue('copyTakeProfit', true);
                                        //   setFieldValue('copyStopLoss', true);
                                        //   // setFieldValue('copyPendingOrders', false);
                                        // }
                                      }}
                                    />
                                  }
                                  label={'Contract Alignment'}
                                  labelPlacement="end"
                                  sx={{ ml: 1, mr: 1 }}
                                />
                              </Grid>
                              <Grid item xs={4}>
                                <FormControlLabel
                                  value="start"
                                  control={
                                    <Checkbox
                                      name="copyExpiryTime"
                                      checked={values.copyExpiryTime}
                                      onChange={(e, value) => {
                                        setFieldValue('copyExpiryTime', value);
                                        // if (value) {
                                        //   setFieldValue('copyTakeProfit', true);
                                        //   setFieldValue('copyStopLoss', true);
                                        //   // setFieldValue('copyPendingOrders', false);
                                        // }
                                      }}
                                    />
                                  }
                                  label={'Copy Expiry Time'}
                                  labelPlacement="end"
                                  sx={{ mr: 1 }}
                                />
                              </Grid>
                              <Grid item xs={4}>
                                <FormControlLabel
                                  value="start"
                                  control={
                                    <Checkbox
                                      name="strictClose"
                                      checked={values.strictClose}
                                      onChange={(e, value) => {
                                        setFieldValue('strictClose', value);
                                        if (value) {
                                          if (values.fixedStopLoss === 'No') {
                                            setFieldValue('copyStopLoss', true);
                                          }
                                          if (values.fixedTakeProfit === 'No') {
                                            setFieldValue('copyTakeProfit', true);
                                          }
                                        }
                                      }}
                                    />
                                  }
                                  label={'Strict Close'}
                                  labelPlacement="end"
                                  sx={{ mr: 1 }}
                                />
                                <Tooltip
                                  title={
                                    <Typography
                                      color={
                                        theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.typography.caption.color
                                      }
                                      variant={'caption'}
                                    >
                                      High risk option, click to learn more
                                    </Typography>
                                  }
                                >
                                  <WarningOutlined
                                    style={{ color: theme.palette.error.main, verticalAlign: 'middle' }}
                                    onClick={() => {
                                      window.open('https://docs.tradersconnect.com/trade-copier/copier-options/#strict-close', '_blank');
                                    }}
                                  />
                                </Tooltip>
                              </Grid>
                            </Grid>

                            {isComment() && (
                              <Grid item xs={12} sx={{ mt: 3 }} justifyContent={'space-between'} display={'flex'}>
                                <Grid sx={{ mr: 2 }} item xs={6}>
                                  <Stack spacing={1}>
                                    {isSeacrest && (
                                      <Tooltip
                                        title={
                                          <Typography
                                            color={
                                              theme.palette.mode === 'dark'
                                                ? theme.palette.background.paper
                                                : theme.typography.caption.color
                                            }
                                            variant={'caption'}
                                          >
                                            {isSeacrest ? 'Seacrest Markets' : 'CTI'} does not allow this feature
                                          </Typography>
                                        }
                                      >
                                        <FormControl fullWidth>
                                          <InputLabel
                                            style={{ minHeight: '14px', lineHeight: '12px' }}
                                            error={Boolean(touched.copyComment && errors.copyComment)}
                                            id="copy-comment"
                                          >
                                            Copy Trade Comment
                                          </InputLabel>
                                          <Select
                                            labelId="copy-comment"
                                            id="copy-comment"
                                            name="copyComment"
                                            placeholder="Copy Comment"
                                            value={values.copyComment}
                                            onBlur={handleBlur}
                                            // onChange={handleChange}
                                            disabled={isSeacrest}
                                            onChange={(e, v) => {
                                              setFieldValue('copyComment', e?.target?.value);
                                              setFieldValue('customComment', '');
                                            }}
                                            error={Boolean(touched.copyComment && errors.copyComment)}
                                          >
                                            <MenuItem value={'No'}>No</MenuItem>
                                            <MenuItem value={'Yes'}>Yes</MenuItem>
                                            <MenuItem value={'Custom'}>Custom</MenuItem>
                                          </Select>
                                        </FormControl>
                                      </Tooltip>
                                    )}
                                    {!isSeacrest && (
                                      <FormControl fullWidth>
                                        <InputLabel
                                          style={{ minHeight: '14px', lineHeight: '12px' }}
                                          error={Boolean(touched.copyComment && errors.copyComment)}
                                          id="copy-comment"
                                        >
                                          Copy Trade Comment
                                        </InputLabel>
                                        <Select
                                          labelId="copy-comment"
                                          id="copy-comment"
                                          name="copyComment"
                                          placeholder="Copy Comment"
                                          value={values.copyComment}
                                          onBlur={handleBlur}
                                          // onChange={handleChange}
                                          onChange={(e, v) => {
                                            setFieldValue('copyComment', e?.target?.value);
                                            setFieldValue('customComment', '');
                                          }}
                                          error={Boolean(touched.copyComment && errors.copyComment)}
                                        >
                                          <MenuItem value={'No'}>No</MenuItem>
                                          <MenuItem value={'Yes'}>Yes</MenuItem>
                                          <MenuItem value={'Custom'}>Custom</MenuItem>
                                        </Select>
                                      </FormControl>
                                    )}

                                    {touched.copyComment && errors.copyComment && (
                                      <FormHelperText error id="helper-text-copyComment">
                                        {errors.copyComment}
                                      </FormHelperText>
                                    )}
                                  </Stack>
                                </Grid>
                                <Grid item xs={6}>
                                  <Stack spacing={1}>
                                    <FormControl variant="outlined">
                                      <InputLabel
                                        disabled={values.copyComment !== 'Custom'}
                                        sx={{ minHeight: '14px', lineHeight: '12px' }}
                                        htmlFor="custom-comment"
                                      >
                                        Enter Custom Comment
                                      </InputLabel>
                                      <OutlinedInput
                                        fullWidth
                                        error={Boolean(touched.customComment && errors.customComment)}
                                        label={'Custom Comment'}
                                        inputProps={{ style: { minHeight: '14px', lineHeight: '12px' } }}
                                        id="custom-comment"
                                        type="text"
                                        value={values?.copyComment === 'Custom' ? values.customComment : ''}
                                        name="customComment"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        placeholder="Custom Comment"
                                        disabled={values.copyComment !== 'Custom'}
                                        readOnly={values.copyComment !== 'Custom'}
                                      />
                                    </FormControl>
                                    {touched.customComment && errors.customComment && (
                                      <FormHelperText error id="helper-text-customComment">
                                        Maximum length of custom comment is 25
                                      </FormHelperText>
                                    )}
                                  </Stack>
                                </Grid>
                              </Grid>
                            )}

                            <Grid item xs={12} sx={{ mt: 3 }} justifyContent={'space-between'} display={'flex'}>
                              <Grid sx={{ mr: 2 }} item xs={6}>
                                <Stack spacing={1}>
                                  {(isCTIAccount || isSeacrest || hasTVAccount()) && (
                                    <Tooltip
                                      title={
                                        <Typography
                                          color={
                                            theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.typography.caption.color
                                          }
                                          variant={'caption'}
                                        >
                                          {hasTVAccount() ? 'Tradovate master' : isSeacrest ? 'Seacrest Markets' : 'CTI'} does not allow
                                          this feature
                                        </Typography>
                                      }
                                    >
                                      <FormControl fullWidth>
                                        <InputLabel
                                          style={{ minHeight: '14px', lineHeight: '12px' }}
                                          error={Boolean(touched.copyComment && errors.copyComment)}
                                          id="copy-magic-number"
                                        >
                                          Copy Magic Number
                                        </InputLabel>
                                        <Select
                                          labelId="copy-magic-number"
                                          id="copy-magic-number"
                                          name="copyMagicNumber"
                                          placeholder="Copy Magic Number"
                                          value={values.copyMagicNumber}
                                          disabled={isCTIAccount || isSeacrest || hasTVAccount()}
                                          onBlur={handleBlur}
                                          // onChange={handleChange}
                                          onChange={(e, v) => {
                                            setFieldValue('copyMagicNumber', e?.target?.value);
                                            setFieldValue('magicNumber', '');
                                          }}
                                          error={Boolean(touched.copyMagicNumber && errors.copyMagicNumber)}
                                        >
                                          <MenuItem value={'No'}>No</MenuItem>
                                          <MenuItem value={'Yes'}>Yes</MenuItem>
                                          <MenuItem value={'Custom'}>Custom</MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Tooltip>
                                  )}
                                  {!(isCTIAccount || isSeacrest || hasTVAccount()) && (
                                    <FormControl fullWidth>
                                      <InputLabel
                                        style={{ minHeight: '14px', lineHeight: '12px' }}
                                        error={Boolean(touched.copyComment && errors.copyComment)}
                                        id="copy-magic-number"
                                      >
                                        Copy Magic Number
                                      </InputLabel>
                                      <Select
                                        labelId="copy-magic-number"
                                        id="copy-magic-number"
                                        name="copyMagicNumber"
                                        placeholder="Copy Magic Number"
                                        value={values.copyMagicNumber}
                                        onBlur={handleBlur}
                                        // onChange={handleChange}
                                        onChange={(e, v) => {
                                          setFieldValue('copyMagicNumber', e?.target?.value);
                                          setFieldValue('magicNumber', '');
                                        }}
                                        error={Boolean(touched.copyMagicNumber && errors.copyMagicNumber)}
                                      >
                                        <MenuItem value={'No'}>No</MenuItem>
                                        <MenuItem value={'Yes'}>Yes</MenuItem>
                                        <MenuItem value={'Custom'}>Custom</MenuItem>
                                      </Select>
                                    </FormControl>
                                  )}
                                  {touched.copyMagicNumber && errors.copyMagicNumber && (
                                    <FormHelperText error id="helper-text-copyMagicNumber">
                                      {errors.copyMagicNumber}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                              <Grid item xs={6}>
                                <Stack spacing={1}>
                                  <FormControl variant="outlined">
                                    <InputLabel
                                      disabled={values.copyMagicNumber !== 'Custom'}
                                      sx={{ minHeight: '14px', lineHeight: '12px' }}
                                      htmlFor="magic-number"
                                    >
                                      Enter Magic Number
                                    </InputLabel>
                                    <OutlinedInput
                                      fullWidth
                                      error={Boolean(touched.magicNumber && errors.magicNumber)}
                                      label={'Magic Number'}
                                      inputProps={{ style: { minHeight: '14px', lineHeight: '12px' } }}
                                      id="magic-number"
                                      type="number"
                                      value={values?.copyMagicNumber === 'Custom' ? values.magicNumber : ''}
                                      name="magicNumber"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      placeholder="Enter Magic Number"
                                      disabled={values.copyMagicNumber !== 'Custom'}
                                      readOnly={values.copyMagicNumber !== 'Custom'}
                                    />
                                  </FormControl>
                                  {touched.magicNumber && errors.magicNumber && (
                                    <FormHelperText error id="helper-text-magicNumber">
                                      {errors.magicNumber}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                            </Grid>

                            <Grid item sx={{ mt: 3 }} display={'flex'} xs={12}>
                              <Grid item sx={{ mr: 2 }} xs={12}>
                                <Stack spacing={1}>
                                  {(isCTIAccount || isSeacrest) && (
                                    <Tooltip
                                      title={
                                        <Typography
                                          color={
                                            theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.typography.caption.color
                                          }
                                          variant={'caption'}
                                        >
                                          {isSeacrest ? 'Seacrest Markets' : 'CTI'} does not allow this feature
                                        </Typography>
                                      }
                                    >
                                      <FormControl fullWidth>
                                        <InputLabel
                                          style={{ minHeight: '14px', lineHeight: '12px' }}
                                          error={Boolean(touched.delayType && errors.delayType)}
                                          id="delayType"
                                        >
                                          Delay type
                                        </InputLabel>
                                        <Select
                                          labelId="delayType"
                                          id="delayType"
                                          name="delayType"
                                          placeholder="Delay type"
                                          value={values.delayType}
                                          disabled={isCTIAccount || isSeacrest}
                                          onBlur={handleBlur}
                                          error={Boolean(touched.delayType && errors.delayType)}
                                        >
                                          <MenuItem value={'no'}>No trade delay</MenuItem>
                                          <MenuItem value={'fixed'}>Fixed trade delay</MenuItem>
                                          <MenuItem value={'random'}>Random trade delay</MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Tooltip>
                                  )}
                                  {!(isCTIAccount || isSeacrest) && (
                                    <FormControl fullWidth>
                                      <InputLabel
                                        style={{ minHeight: '14px', lineHeight: '12px' }}
                                        error={Boolean(touched.delayType && errors.delayType)}
                                        id="delayType"
                                      >
                                        Delay type
                                      </InputLabel>
                                      <Select
                                        labelId="delayType"
                                        id="delayType"
                                        name="delayType"
                                        placeholder="Delay type"
                                        value={values.delayType}
                                        onBlur={handleBlur}
                                        onChange={(e, v) => {
                                          setFieldValue('delayType', e?.target?.value);
                                          setFieldValue('tradeDelayMin', '');
                                          setFieldValue('tradeDelayMax', '');
                                        }}
                                        error={Boolean(touched.delayType && errors.delayType)}
                                      >
                                        <MenuItem value={'no'}>No trade delay</MenuItem>
                                        <MenuItem value={'fixed'}>Fixed trade delay</MenuItem>
                                        <MenuItem value={'random'}>Random trade delay</MenuItem>
                                      </Select>
                                    </FormControl>
                                  )}
                                  {touched.delayType && errors.delayType && (
                                    <FormHelperText error id="helper-text-delayType">
                                      {errors.delayType}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                              <Grid item xs={12}>
                                <Stack spacing={1}>
                                  <FormControl variant="outlined">
                                    <InputLabel
                                      disabled={values.delayType === 'no'}
                                      sx={{ minHeight: '14px', lineHeight: '12px' }}
                                      htmlFor="tradeDelayMin"
                                    >
                                      Trade Delay (ms){values.delayType === 'random' ? ' - Minimum' : ''}
                                    </InputLabel>
                                    <OutlinedInput
                                      fullWidth
                                      error={Boolean(touched.tradeDelayMin && errors.tradeDelayMin)}
                                      label={'Trade Delay (ms)' + values.delayType === 'random' ? ' - Minimum' : ''}
                                      inputProps={{ style: { minHeight: '14px', lineHeight: '12px' } }}
                                      id="tradeDelayMin"
                                      type="tel"
                                      inputMode="numeric"
                                      value={values.tradeDelayMin}
                                      name="tradeDelayMin"
                                      onBlur={handleBlur}
                                      // onChange={handleChange}
                                      disabled={values.delayType === 'no'}
                                      readOnly={values.delayType === 'no'}
                                      onChange={(e) => {
                                        // Allow only digits (0-9) and update the state
                                        const numericInput = e.target.value.replace(/\D/g, '');
                                        handleChange({
                                          target: {
                                            name: 'tradeDelayMin',
                                            value: numericInput
                                          }
                                        });
                                      }}
                                      placeholder={'Trade Delay (ms)' + values.delayType === 'random' ? ' - Minimum' : ''}
                                      // endAdornment={<InputAdornment position="end">%</InputAdornment>}
                                    />
                                  </FormControl>
                                  {touched.tradeDelayMin && errors.tradeDelayMin && (
                                    <FormHelperText error id="helper-text-tradeDelayMin">
                                      {errors.tradeDelayMin}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                              {values.delayType === 'random' && (
                                <Grid item sx={{ ml: 2 }} xs={12}>
                                  <Stack spacing={1}>
                                    <FormControl variant="outlined">
                                      <InputLabel sx={{ minHeight: '14px', lineHeight: '12px' }} htmlFor="tradeDelayMax">
                                        Trade Delay (ms) - Maximum
                                      </InputLabel>
                                      <OutlinedInput
                                        fullWidth
                                        error={Boolean(touched.tradeDelayMax && errors.tradeDelayMax)}
                                        label={'Trade Delay (ms) - Maximum'}
                                        inputProps={{ style: { minHeight: '14px', lineHeight: '12px' } }}
                                        id="tradeDelayMax"
                                        type="tel"
                                        inputMode="numeric"
                                        value={values.tradeDelayMax}
                                        name="tradeDelayMax"
                                        onBlur={handleBlur}
                                        // onChange={handleChange}
                                        onChange={(e) => {
                                          // Allow only digits (0-9) and update the state
                                          const numericInput = e.target.value.replace(/\D/g, '');
                                          handleChange({
                                            target: {
                                              name: 'tradeDelayMax',
                                              value: numericInput
                                            }
                                          });
                                        }}
                                        placeholder="Trade Delay (ms) - Maximum"
                                        // endAdornment={<InputAdornment position="end">%</InputAdornment>}
                                      />
                                    </FormControl>
                                    {touched.tradeDelayMax && errors.tradeDelayMax && (
                                      <FormHelperText error id="helper-text-tradeDelayMax">
                                        {errors.tradeDelayMax}
                                      </FormHelperText>
                                    )}
                                  </Stack>
                                </Grid>
                              )}
                            </Grid>

                            <Grid item sx={{ mt: 3 }} display={'flex'} xs={12}>
                              <Grid item xs={6}>
                                <Stack spacing={1} sx={{ mr: '8px' }}>
                                  <FormControl variant="outlined">
                                    <InputLabel sx={{ minHeight: '14px', lineHeight: '12px' }} htmlFor="lotRefiner">
                                      Lot Refiner
                                    </InputLabel>
                                    <OutlinedInput
                                      fullWidth
                                      error={Boolean(touched.lotRefiner && errors.lotRefiner)}
                                      label={'Lot Refiner'}
                                      inputProps={{
                                        style: { minHeight: '14px', lineHeight: '12px' },
                                        step: hasTVAccount() ? '1' : '0.01'
                                      }}
                                      id="lotRefiner"
                                      type="number"
                                      value={values.lotRefiner}
                                      name="lotRefiner"
                                      onBlur={handleBlur}
                                      onChange={(e) => {
                                        if (hasTVAccount()) {
                                          const value = e.target.value;
                                          if (value.includes('.')) {
                                            // If decimal is entered, round it to nearest integer
                                            e.target.value = Math.round(parseFloat(value)).toString();
                                          }
                                        }
                                        handleChange(e);
                                      }}
                                      placeholder="Lot Size"
                                      // endAdornment={<InputAdornment position="end">%</InputAdornment>}
                                    />
                                  </FormControl>
                                  {touched.lotRefiner && errors.lotRefiner && (
                                    <FormHelperText error id="helper-text-lotRefiner">
                                      {errors.lotRefiner}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      </Box>
                    </Grid>

                    <Grid item xs={12} style={{ paddingTop: '12px' }}>
                      <Box
                        sx={{
                          '& .MuiAccordion-root': {
                            border: 'none',
                            '& .MuiAccordionSummary-root': {
                              bgcolor: 'transparent',
                              flexDirection: 'row',
                              padding: '0px',
                              '& .MuiAccordionSummary-content': {
                                marginLeft: '0px'
                              }
                            },
                            '& .MuiAccordionDetails-root': {
                              border: 'none',
                              padding: '16px 0px'
                            },
                            '& .Mui-expanded': {}
                          }
                        }}
                      >
                        <Accordion expanded={filterExpanded}>
                          <Grid>
                            <AccordionSummary
                              expandIcon={<CaretRightFilled />}
                              onClick={(e) => {
                                if (!filterExpanded) {
                                  setFilterExpanded(true);
                                  setSlTpExpand(false);
                                  setAdvanceExpanded(false);
                                  setCopyExpanded(false);
                                }
                              }}
                            >
                              <Typography variant={'subtitle1'}>Trade Filters</Typography>
                            </AccordionSummary>
                            <Divider />
                          </Grid>

                          <AccordionDetails>
                            <Grid item xs={12} sx={{ mt: 3 }} justifyContent={'space-between'} display={'flex'}>
                              <Grid sx={{ mr: 2 }} item xs={6}>
                                <Stack spacing={1}>
                                  {hasTVAccount() && (
                                    <Tooltip
                                      title={
                                        <Typography
                                          color={
                                            theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.typography.caption.color
                                          }
                                          variant={'caption'}
                                        >
                                          Tradovate master does not allow this feature
                                        </Typography>
                                      }
                                    >
                                      <FormControl fullWidth>
                                        <InputLabel
                                          style={{ minHeight: '14px', lineHeight: '12px' }}
                                          error={Boolean(touched.magicFilter && errors.magicFilter)}
                                          id="magicFilter"
                                        >
                                          Filter by magic number
                                        </InputLabel>
                                        <Select
                                          labelId="magicFilter"
                                          id="magicFilter"
                                          name="magicFilter"
                                          placeholder="Filter by magic number"
                                          value={values.magicFilter}
                                          onBlur={handleBlur}
                                          // onChange={handleChange}
                                          disabled={true}
                                          onChange={(e, v) => {
                                            // setFieldValue('magicFilter', e?.target?.value);
                                            // setFieldValue('magicFilterValue', '');
                                          }}
                                          error={Boolean(touched.magicFilter && errors.magicFilter)}
                                        >
                                          <MenuItem disabled value={'UNKNOWN'}>
                                            Select an option
                                          </MenuItem>
                                          <MenuItem value={'COPY'}>Copy</MenuItem>
                                          <MenuItem value={'IGNORE'}>Ignore</MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Tooltip>
                                  )}
                                  {!hasTVAccount() && (
                                    <FormControl fullWidth>
                                      <InputLabel
                                        style={{ minHeight: '14px', lineHeight: '12px' }}
                                        error={Boolean(touched.magicFilter && errors.magicFilter)}
                                        id="magicFilter"
                                      >
                                        Filter by magic number
                                      </InputLabel>
                                      <Select
                                        labelId="magicFilter"
                                        id="magicFilter"
                                        name="magicFilter"
                                        placeholder="Filter by magic number"
                                        value={values.magicFilter}
                                        onBlur={handleBlur}
                                        // onChange={handleChange}
                                        onChange={(e, v) => {
                                          setFieldValue('magicFilter', e?.target?.value);
                                          setFieldValue('magicFilterValue', '');
                                        }}
                                        error={Boolean(touched.magicFilter && errors.magicFilter)}
                                      >
                                        <MenuItem disabled value={'UNKNOWN'}>
                                          Select an option
                                        </MenuItem>
                                        <MenuItem value={'COPY'}>Copy</MenuItem>
                                        <MenuItem value={'IGNORE'}>Ignore</MenuItem>
                                      </Select>
                                    </FormControl>
                                  )}
                                  {touched.magicFilter && errors.magicFilter && (
                                    <FormHelperText error id="helper-text-magicFilter">
                                      {errors.magicFilter}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                              <Grid item xs={6}>
                                <Stack spacing={1}>
                                  <Autocomplete
                                    multiple
                                    id="magicFilterValue"
                                    // name="magicFilterValue"
                                    open={false}
                                    forcePopupIcon={false}
                                    clearText={'Remove all'}
                                    options={selectedMagicNumbers}
                                    value={selectedMagicNumbers}
                                    getOptionLabel={(option: any) => option}
                                    disabled={values.magicFilter !== 'COPY' && values.magicFilter !== 'IGNORE'}
                                    readOnly={values.magicFilter !== 'COPY' && values.magicFilter !== 'IGNORE'}
                                    defaultValue={selectedMagicNumbers}
                                    onChange={(event, value) => {
                                      console.log(event, value);
                                      setSelectedMagicNumbers(value);
                                    }}
                                    renderInput={(params) => {
                                      return (
                                        <TextField
                                          {...params}
                                          placeholder="Press enter to add"
                                          value={currentMagicNumber}
                                          type="number"
                                          onChange={(e) => {
                                            setCurrentMagicNumber(e.target.value);
                                          }}
                                          onBlur={() => {
                                            console.log('currentMagicNumber: ', currentMagicNumber);
                                            if (currentMagicNumber) {
                                              setSelectedMagicNumbers((prev) => [...prev, currentMagicNumber]);
                                              setCurrentMagicNumber('');
                                            }
                                          }}
                                          onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                              e.preventDefault();
                                              if (
                                                currentMagicNumber &&
                                                !selectedMagicNumbers.includes(currentMagicNumber) &&
                                                selectedMagicNumbers?.length < 10
                                              ) {
                                                setSelectedMagicNumbers((prev) => [...prev, currentMagicNumber]);
                                                setCurrentMagicNumber('');
                                              } else if (selectedMagicNumbers.includes(currentMagicNumber)) {
                                                service.dispatchSnackbar(
                                                  dispatch,
                                                  "Can't add duplicate magic filters",
                                                  'alert',
                                                  'error',
                                                  2000
                                                );
                                              } else if (selectedMagicNumbers?.length >= 10) {
                                                service.dispatchSnackbar(
                                                  dispatch,
                                                  "Can't add more than 10 magic filters",
                                                  'alert',
                                                  'error',
                                                  2000
                                                );
                                              }
                                            }
                                            console.log('magicFilterValue: ', e);
                                          }}
                                        />
                                      );
                                    }}
                                    sx={{
                                      // '& .MuiOutlinedInput-root': {
                                      //   p: 1
                                      // },
                                      '& .MuiAutocomplete-tag': {
                                        bgcolor: 'primary.lighter',
                                        border: '1px solid',
                                        borderRadius: 1,
                                        height: 32,
                                        pl: 1.5,
                                        pr: 1.5,
                                        lineHeight: '32px',
                                        borderColor: 'primary.light',
                                        '& .MuiChip-label': {
                                          paddingLeft: 0,
                                          paddingRight: 0
                                        },
                                        '& .MuiSvgIcon-root': {
                                          color: 'primary.main',
                                          ml: 1,
                                          mr: -0.75,
                                          '&:hover': {
                                            color: 'primary.dark'
                                          }
                                        }
                                      }
                                    }}
                                  />
                                  {touched.magicFilterValue && errors.magicFilterValue && (
                                    <FormHelperText error id="helper-text-magicFilterValue">
                                      {errors.magicFilterValue}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                            </Grid>

                            <Grid item xs={12} sx={{ mt: 3 }} justifyContent={'space-between'} display={'flex'}>
                              <Grid sx={{ mr: 2 }} item xs={6}>
                                <Stack spacing={1}>
                                  {hasTVAccount() && (
                                    <Tooltip
                                      title={
                                        <Typography
                                          color={
                                            theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.typography.caption.color
                                          }
                                          variant={'caption'}
                                        >
                                          Tradovate master does not allow this feature
                                        </Typography>
                                      }
                                    >
                                      <FormControl fullWidth>
                                        <InputLabel
                                          style={{ minHeight: '14px', lineHeight: '12px' }}
                                          error={Boolean(touched.filterByComment && errors.filterByComment)}
                                          id="filterByComment"
                                        >
                                          Filter by comment
                                        </InputLabel>
                                        <Select
                                          labelId="filterByComment"
                                          id="filterByComment"
                                          name="filterByComment"
                                          placeholder="Filter by comment"
                                          value={values.filterByComment}
                                          disabled={true}
                                          onBlur={handleBlur}
                                          onChange={(e, v) => {
                                            // setFieldValue('filterByComment', e?.target?.value);
                                            // setFieldValue('filterByCommentValue', '');
                                          }}
                                          error={Boolean(touched.filterByComment && errors.filterByComment)}
                                        >
                                          <MenuItem disabled value={'UNKNOWN'}>
                                            Select an option
                                          </MenuItem>
                                          <MenuItem value={'COPY'}>Copy</MenuItem>
                                          <MenuItem value={'IGNORE'}>Ignore</MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Tooltip>
                                  )}
                                  {!hasTVAccount() && (
                                    <FormControl fullWidth>
                                      <InputLabel
                                        style={{ minHeight: '14px', lineHeight: '12px' }}
                                        error={Boolean(touched.filterByComment && errors.filterByComment)}
                                        id="filterByComment"
                                      >
                                        Filter by comment
                                      </InputLabel>
                                      <Select
                                        labelId="filterByComment"
                                        id="filterByComment"
                                        name="filterByComment"
                                        placeholder="Filter by comment"
                                        value={values.filterByComment}
                                        onBlur={handleBlur}
                                        onChange={(e, v) => {
                                          setFieldValue('filterByComment', e?.target?.value);
                                          setFieldValue('filterByCommentValue', '');
                                        }}
                                        error={Boolean(touched.filterByComment && errors.filterByComment)}
                                      >
                                        <MenuItem disabled value={'UNKNOWN'}>
                                          Select an option
                                        </MenuItem>
                                        <MenuItem value={'COPY'}>Copy</MenuItem>
                                        <MenuItem value={'IGNORE'}>Ignore</MenuItem>
                                      </Select>
                                    </FormControl>
                                  )}
                                  {touched.filterByComment && errors.filterByComment && (
                                    <FormHelperText error id="helper-text-filterByComment">
                                      {errors.filterByComment}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                              <Grid item xs={6}>
                                <Stack spacing={1}>
                                  <Autocomplete
                                    multiple
                                    id="filterByCommentValue"
                                    open={false}
                                    forcePopupIcon={false}
                                    clearText={'Remove all'}
                                    options={selectedComments}
                                    value={selectedComments}
                                    getOptionLabel={(option: any) => option}
                                    disabled={values.filterByComment !== 'COPY' && values.filterByComment !== 'IGNORE'}
                                    readOnly={values.filterByComment !== 'COPY' && values.filterByComment !== 'IGNORE'}
                                    defaultValue={selectedComments}
                                    onChange={(event, value) => {
                                      console.log(event, value);
                                      setSelectedComments(value);
                                    }}
                                    renderInput={(params) => {
                                      return (
                                        <TextField
                                          {...params}
                                          placeholder="Press enter to add"
                                          value={currentComment}
                                          onChange={(e) => {
                                            setCurrentComment(e.target.value);
                                          }}
                                          onBlur={() => {
                                            if (currentComment) {
                                              setSelectedComments((prev) => [...prev, currentComment]);
                                              setCurrentComment('');
                                            }
                                          }}
                                          onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                              e.preventDefault();
                                              if (
                                                currentComment &&
                                                !selectedComments.includes(currentComment) &&
                                                selectedComments.length < 10
                                              ) {
                                                setSelectedComments((prev) => [...prev, currentComment]);
                                                setCurrentComment('');
                                              } else if (selectedComments.includes(currentComment)) {
                                                service.dispatchSnackbar(
                                                  dispatch,
                                                  "Can't add duplicate comment filters",
                                                  'alert',
                                                  'error',
                                                  2000
                                                );
                                              } else if (selectedComments.length >= 10) {
                                                service.dispatchSnackbar(
                                                  dispatch,
                                                  "Can't add more than 10 comment filters",
                                                  'alert',
                                                  'error',
                                                  2000
                                                );
                                              }
                                            }
                                            console.log('filterByCommentValue: ', e);
                                          }}
                                        />
                                      );
                                    }}
                                    sx={{
                                      // '& .MuiOutlinedInput-root': {
                                      //   p: 1
                                      // },
                                      '& .MuiAutocomplete-tag': {
                                        bgcolor: 'primary.lighter',
                                        border: '1px solid',
                                        borderRadius: 1,
                                        height: 32,
                                        pl: 1.5,
                                        pr: 1.5,
                                        lineHeight: '32px',
                                        borderColor: 'primary.light',
                                        '& .MuiChip-label': {
                                          paddingLeft: 0,
                                          paddingRight: 0,
                                          whiteSpace: 'pre'
                                        },
                                        '& .MuiSvgIcon-root': {
                                          color: 'primary.main',
                                          ml: 1,
                                          mr: -0.75,
                                          '&:hover': {
                                            color: 'primary.dark'
                                          }
                                        }
                                      }
                                    }}
                                  />
                                  {touched.filterByCommentValue && errors.filterByCommentValue && (
                                    <FormHelperText error id="helper-text-filterByCommentValue">
                                      {errors.filterByCommentValue}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                            </Grid>

                            <Grid item xs={12} sx={{ mt: 3 }} display={'flex'}>
                              <Grid sx={{ mr: 2 }} item xs={6}>
                                <Stack>
                                  <FormControl fullWidth>
                                    <InputLabel
                                      style={{ minHeight: '14px', lineHeight: '12px' }}
                                      error={Boolean(touched.directionType && errors.directionType)}
                                      id="directionLabelType"
                                    >
                                      Trade Side
                                    </InputLabel>
                                    <Select
                                      labelId="directionLabelType"
                                      id="directionType"
                                      name="directionType"
                                      placeholder="Trade Side"
                                      value={values.directionType}
                                      onBlur={handleBlur}
                                      onChange={(e, value) => {
                                        setFieldValue('directionType', e.target.value);
                                      }}
                                      error={Boolean(touched.directionType && errors.directionType)}
                                    >
                                      <MenuItem value={'ALL'}>Copy All trades</MenuItem>
                                      <MenuItem value={'BUY'}>Copy Buy trades</MenuItem>
                                      <MenuItem value={'SELL'}>Copy Sell trades</MenuItem>
                                    </Select>
                                    {touched.directionType && errors.directionType && (
                                      <FormHelperText error id="helper-text-directionType">
                                        {errors.directionType}
                                      </FormHelperText>
                                    )}
                                  </FormControl>
                                </Stack>
                              </Grid>
                              <Grid item xs={6}></Grid>
                            </Grid>

                            <Grid item xs={12} sx={{ mt: 3 }} justifyContent={'space-between'} display={'flex'}>
                              <Grid sx={{ mr: 2 }} item xs={4}>
                                <Stack spacing={1}>
                                  <FormControl fullWidth>
                                    <InputLabel
                                      style={{ minHeight: '14px', lineHeight: '12px' }}
                                      error={Boolean(touched.filterByLotSize && errors.filterByLotSize)}
                                      id="filterByLotSize"
                                    >
                                      Filter by lot size
                                    </InputLabel>
                                    <Select
                                      labelId="filterByLotSize"
                                      id="filterByLotSize"
                                      name="filterByLotSize"
                                      placeholder="Filter by lot size"
                                      value={values.filterByLotSize}
                                      onBlur={handleBlur}
                                      onChange={(e, v) => {
                                        setFieldValue('filterByLotSize', e?.target?.value);
                                        setFieldValue('filterByLotSizeMinValue', '');
                                        setFieldValue('filterByLotSizeMaxValue', '');
                                      }}
                                      error={Boolean(touched.filterByLotSize && errors.filterByLotSize)}
                                    >
                                      <MenuItem value={'No'}>No</MenuItem>
                                      <MenuItem value={'Yes'}>Yes</MenuItem>
                                    </Select>
                                  </FormControl>
                                  {touched.filterByLotSize && errors.filterByLotSize && (
                                    <FormHelperText error id="helper-text-filterByLotSize">
                                      {errors.filterByLotSize}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                              <Grid sx={{ mr: 2 }} item xs={4}>
                                <Stack spacing={1}>
                                  <FormControl variant="outlined">
                                    <InputLabel
                                      error={Boolean(touched.filterByLotSizeMinValue && errors.filterByLotSizeMinValue)}
                                      disabled={values.filterByLotSize !== 'Yes'}
                                      sx={{ minHeight: '14px', lineHeight: '12px' }}
                                      htmlFor="filterByLotSizeMinValue"
                                    >
                                      Enter minimum lot size
                                    </InputLabel>
                                    <OutlinedInput
                                      fullWidth
                                      error={Boolean(touched.filterByLotSizeMinValue && errors.filterByLotSizeMinValue)}
                                      label={'Minimum lot size'}
                                      inputProps={{
                                        style: { minHeight: '14px', lineHeight: '12px' },
                                        step: hasTVAccount() ? '1' : '0.01'
                                      }}
                                      id="filterByLotSizeMinValue"
                                      type="number"
                                      value={values?.filterByLotSize === 'Yes' ? values.filterByLotSizeMinValue : ''}
                                      name="filterByLotSizeMinValue"
                                      onBlur={handleBlur}
                                      onChange={(e) => {
                                        if (hasTVAccount()) {
                                          const value = e.target.value;
                                          if (value.includes('.')) {
                                            // If decimal is entered, round it to nearest integer
                                            e.target.value = Math.round(parseFloat(value)).toString();
                                          }
                                        }
                                        handleChange(e);
                                      }}
                                      placeholder="Enter minimum lot size"
                                      disabled={values.filterByLotSize !== 'Yes'}
                                      readOnly={values.filterByLotSize !== 'Yes'}
                                    />
                                  </FormControl>
                                  {touched.filterByLotSizeMinValue && errors.filterByLotSizeMinValue && (
                                    <FormHelperText error id="helper-text-filterByLotSizeMinValue">
                                      {errors.filterByLotSizeMinValue}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                              <Grid item xs={4}>
                                <Stack spacing={1}>
                                  <FormControl variant="outlined">
                                    <InputLabel
                                      error={Boolean(touched.filterByLotSizeMaxValue && errors.filterByLotSizeMaxValue)}
                                      disabled={values.filterByLotSize !== 'Yes'}
                                      sx={{ minHeight: '14px', lineHeight: '12px' }}
                                      htmlFor="filterByLotSizeMaxValue"
                                    >
                                      Enter maximum lot size
                                    </InputLabel>
                                    <OutlinedInput
                                      fullWidth
                                      error={Boolean(touched.filterByLotSizeMaxValue && errors.filterByLotSizeMaxValue)}
                                      label={'Maximum lot size'}
                                      inputProps={{
                                        style: { minHeight: '14px', lineHeight: '12px' },
                                        step: hasTVAccount() ? '1' : '0.01'
                                      }}
                                      id="filterByLotSizeMaxValue"
                                      type="number"
                                      value={values?.filterByLotSize === 'Yes' ? values.filterByLotSizeMaxValue : ''}
                                      name="filterByLotSizeMaxValue"
                                      onBlur={handleBlur}
                                      onChange={(e) => {
                                        if (hasTVAccount()) {
                                          const value = e.target.value;
                                          if (value.includes('.')) {
                                            // If decimal is entered, round it to nearest integer
                                            e.target.value = Math.round(parseFloat(value)).toString();
                                          }
                                        }
                                        handleChange(e);
                                      }}
                                      placeholder="Enter maximum lot size"
                                      disabled={values.filterByLotSize !== 'Yes'}
                                      readOnly={values.filterByLotSize !== 'Yes'}
                                    />
                                  </FormControl>
                                  {touched.filterByLotSizeMaxValue && errors.filterByLotSizeMaxValue && (
                                    <FormHelperText error id="helper-text-filterByLotSizeMaxValue">
                                      {errors.filterByLotSizeMaxValue}
                                    </FormHelperText>
                                  )}
                                </Stack>
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      </Box>
                    </Grid>

                    {errors.submit && (
                      <Grid item xs={12}>
                        <FormHelperText error>{errors.submit}</FormHelperText>
                      </Grid>
                    )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    container
                    display={'-webkit-box'}
                    flexDirection={'column'}
                    justifyContent={'space-between'}
                    alignItems="flex-start"
                  >
                    <Grid item display="flex" justifyContent="start" alignItems="flex-start">
                      <img
                        onClick={() => {
                          setOpenRiskCalculator(true);
                        }}
                        style={{ height: '22px', marginTop: 'auto', marginBottom: 'auto', marginRight: '8px', cursor: 'pointer' }}
                        src={CalculatorSvg}
                      />
                      <span style={{ lineHeight: '36.5px' }}>
                        Calculate your risk setting,
                        <span
                          onClick={() => {
                            /*window.open(
                                          'https://docs.tradersconnect.com/trade-copier/copier-management#add-additional-slaves',
                                          '_blank'
                                        );*/
                            setOpenRiskCalculator(true);
                          }}
                          style={{ cursor: 'pointer', color: theme.palette.primary.main }}
                        >
                          {' '}
                          click here
                        </span>
                      </span>
                    </Grid>
                    <Grid item display="flex" justifyContent="end" alignItems="flex-start">
                      <div style={{ marginRight: '8px' }}>
                        <Button
                          sx={{ paddingX: '24px' }}
                          onClick={() => {
                            handleClose(hasUnsavedChanges(initialValues, values));
                          }}
                          disableElevation
                          fullWidth
                          variant="outlined"
                          color="secondary"
                        >
                          Cancel
                        </Button>
                      </div>
                      <div>
                        <LoadingButton
                          sx={{ paddingX: '24px' }}
                          loadingPosition="end"
                          endIcon={<></>}
                          loading={isSubmitting || apiCalling}
                          disableElevation
                          disabled={isSubmitting || apiCalling}
                          fullWidth
                          type="submit"
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            handleEditSlave(values);
                            handleSubmit();
                          }}
                        >
                          Confirm
                        </LoadingButton>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Modal
                  open={openRiskCalculator}
                  onClose={() => {
                    setOpenRiskCalculator(false);
                  }}
                  aria-labelledby="child-modal-title"
                  aria-describedby="child-modal-description"
                  sx={{ zIndex: (theme) => theme.zIndex.drawer + 1100 }}
                >
                  <Box sx={{ ...style, minWidth: 540, maxWidth: 620 }}>
                    <RiskCalculatorModal
                      handleClose={() => setOpenRiskCalculator(false)}
                      handleSuccess={(riskType: 'percentage' | 'lot' | 'fixedLot' | '' | null, value: string) => {
                        console.log(riskType, riskType === 'percentage' ? RISK_TYPE.BALANCE_MULTIPLIER : RISK_TYPE.LOT_MULTIPLIER);
                        if (riskType) {
                          setFieldValue(
                            'riskType',
                            riskType === 'percentage'
                              ? RISK_TYPE.BALANCE_MULTIPLIER
                              : riskType === 'lot'
                              ? RISK_TYPE.LOT_MULTIPLIER
                              : RISK_TYPE.FIXED_LOT
                          );
                          if (riskType !== 'fixedLot') {
                            setFieldValue('riskSettings', value);
                          } else {
                            setFieldValue('riskSettingsFixedLot', value);
                          }
                          if (riskType === 'percentage') {
                            setFieldValue('considerContractSize', true);
                          }
                        }
                        setOpenRiskCalculator(false);
                      }}
                    />
                  </Box>
                </Modal>
              </form>
            )}
          </Formik>
        </Grid>
  );

  return (
    <>
      {showWrapper ? (
        <MainCard
          title={
            <Typography fontWeight={700} fontSize={16}>
              Override Settings
            </Typography>
          }
          secondary={
            <IconButton
              size="small"
              onClick={() => {
                handleClose(hasUnsavedChanges(initialValues, formValues));
              }}
            >
              <CloseOutlined />
            </IconButton>
          }
          sx={{ minHeight: 350, maxHeight: '95vh', overflowY: 'scroll' }}
        >
          {formContent}
        </MainCard>
      ) : (
        formContent
      )}
    </>
  );
};

export default SymbolSettingsForm;
